import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import { useAppDispatch, useAppSelector } from "../../../../redux/hooks";
import {
  onUploadWorkingDocument as onUploadWorkingDocumentAction,
  onDocumentRevisionSearch as onDocumentRevisionSearchAction,
} from "../../../../redux/slices/documentsAction";
import { fetchDocumentRevisionInfo } from "../../../../redux/slices/documents/documentRevisionInfoSlice";
import { useWorkingDocument } from "../../../../redux/hooks/useWorkingDocument";
import { useCheckin } from "../../../../redux/hooks/useCheckin";
import { useMetadata } from "../../../../redux/hooks/useMetadata";
import { useLogin } from "../../../../redux/hooks/useLogin";
import { useDocuments } from "../../../../redux/hooks/useDocuments";
import { useCheckout } from "../../../../redux/hooks/useCheckout";
import { useTools } from "../../../../redux/hooks/useTools";
import { useOneDrive } from "../../../../redux/hooks/useOneDrive";
import { usePreviewInTeams } from "../../../../redux/hooks/usePreviewInTeams";
import { useUploadToOneDrive } from "../../../../redux/hooks/useUploadToOneDrive";
import { useDeleteWorkingDocument } from "../../../../redux/hooks/useDeleteWorkingDocument";
import { useOpenInIFS } from "../../../../redux/hooks/useOpenInIFS";
import { useTeamsRequestContext } from "../../../../redux/hooks/useTeamsRequestContext";
import CustomerConfig from "../../../../azure/CustomerConfig";
import {
  DATA_LOAD_STATUS,
  PROGRESS_STATUS,
  CHECKIN_NEW_PAGE_NAME,
  DOCUMENT_MODE,
  CHECKIN_NEW,
  CHECKIN_NEW_REVISION,
  DOC_CHECK_IN_TYPE,
  ONEDRIVE_ROOT,
  DOCUMENT_LOAD_STATUS,
  FILE_STATE,
  FILE_TYPES,
  STATE,
  CHECKIN_BUTTON_TEXT_TYPE,
  REFRESH_TOKEN_ACTION,
  RESPONSE_TYPE,
  PAGE_NAME,
} from "../../../../redux/constants/metaData";
import {
  ON_ATTACHED_DOC_INFO,
  ON_CHECKOUT_DOCUMENT_CHANGE,
} from "../../../../redux/constants/actionTypes";
import {
  ERROR_TYPE,
  ONEDRIVE_DATA_NOT_FOUND,
  CHECKIN_SUCCESS_TITLE,
  getSuccessMessage,
  DocumentCheckin,
  DELETE_DOCUMENT_TITLE,
  DELETE_DOCUMENT_SUB_TITLE,
  UNDOCHECKOUT_NOT_FOUND,
  UNDO_CHECKOUT_DELETE_CONFIRMATION_TITLE,
  UNDO_CHECKOUT_DELETE_PENDING,
  getUndoCheckoutDeleteConfirmation,
} from "../../../../redux/constants/messageTypes";
import {
  getDocumentRevision,
  getDocClassCodeOnly,
  getFileName,
  getTitle,
  isWorkingDocumentCheckedOut,
  isWorkingDocumentDownloaded,
  getWorkingDocumentEditedLabel,
  isDocumentReleased,
} from "../../../../functions/helperMethod";
import DocIconTooltip from "../../../../components/Tooltip/Tooltip";
import { formatIfsDocumentLastActionDisplay } from "../../../../functions/dateFormater";
import { getDocumentClassFormatLabel } from "../../../../functions/getDocumentClassFormatLabel";
import { resolveLastAction } from "../../../../functions/resolveDocumentListLastAction";
import { isValidPlayload } from "../../../../functions/reduxMethod";
import { useNavigate, useLocation } from "react-router-dom";
import { APP_ROUTES, NAV_LOCATION_STATE } from "../../../../routes/routeConfig";
import { logger } from "../../../../utils/logger";
import { openExternalUrl } from "../../../../utils/openExternalUrl";
import { resolveEditInBrowserUrl } from "../../../../utils/resolveEditInBrowserUrl";
import Typography from "@mui/material/Typography";
import ToggleButton from "@mui/material/ToggleButton";
import ViewModuleIcon from "@mui/icons-material/ViewModule";
import ListAltOutlinedIcon from "@mui/icons-material/ListAltOutlined";
import { IconButton } from "@fluentui/react";
import { Selection } from "@fluentui/react/lib/DetailsList";

import wordIcon from "../../../../assets/workingDocIcons/wordIcon.png";
import excelIcon from "../../../../assets/workingDocIcons/excelIcon.png";
import pdfIcon from "../../../../assets/workingDocIcons/pdfIcon.png";
import pptIcon from "../../../../assets/workingDocIcons/pptIcon.png";
import wordIconAvatar from "../../../../assets/workingDocIcons/wordIconAvatar.png";
import excelIconAvatar from "../../../../assets/workingDocIcons/excelIconAvatar.png";
import pdfIconAvatar from "../../../../assets/workingDocIcons/pdfIconAvatar.png";
import pptIconAvatar from "../../../../assets/workingDocIcons/pptIconAvatar.png";

import outlookIconAvatar from "../../../../assets/workingDocIcons/outlookIconAvatar.png";
import imageIconAvatar from "../../../../assets/workingDocIcons/imageIconAvatar.png";
import audioIconAvatar from "../../../../assets/workingDocIcons/audioIconAvatar.png";
import videoIconAvatar from "../../../../assets/workingDocIcons/vedioIconAvatar.png";
import archiveIconAvatar from "../../../../assets/workingDocIcons/archiveAvatar.png";
import textIconAvatar from "../../../../assets/workingDocIcons/textIconAvatar.png";
import otherFileIcon from "../../../../assets/workingDocIcons/otherFile.png";
import { OAS365ICONS } from "../../../../icons";
import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import Loader from "../../../../components/LoadSpinner";
import SearchBar from "../../../../components/common/SearchBar";
import DocumentsPagination from "../all-documents/DocumentsPagination";
import { useTheme } from "../../../../theme/OAS365Theme";
import DocumentsTable from "../all-documents/DocumentsTable";
import wordFilterIcon from "../../../../assets/word.svg";
import excelFilterIcon from "../../../../assets/excel.svg";
import pdfFilterIcon from "../../../../assets/icons/pdf.png";
import powerpointFilterIcon from "../../../../assets/powerpoint.svg";
import { WorkingDocumentsNoDataDisplay } from "./WorkingDocumentsNoDataDisplay";
import { WorkingDocumentsErrorDisplay } from "./WorkingDocumentsErrorDisplay";
import ConfirmModal from "../../../../components/popupModals/ConfirmModal";
import { ReusableDialog } from "../../../../components/popupModals/ReusableDialog";
import ReusableMessageDialog from "../../../../components/popupModals/ReusableMessageDialog";
import DocumentDetailsLoadingContent from "../../../../components/moreDetails/DocumentDetailsLoadingContent";
import WorkingDocumentCard, {
  getRelativeTime,
  getRelativeTimeTooltip,
} from "./WorkingDocumentCard";
import { useSearchPanel } from "../../../../theme/styles/SearchPanelStyle";
import {
  WorkingDocumentDetailsDialog,
  CheckinExistingProcessDialog,
} from "./dialogs";
import { useCheckinExistingFlow } from "../../../../redux/hooks/useCheckinExistingFlow";
import { CHECKIN_EXISTING_STATUS } from "../../../../redux/slices/documents/checkinExistingFlowSlice";

import { normalizeDocumentRevisionInfoResponse } from "../../../../utils/normalizeDocumentRevisionInfoResponse";

function pickRevisionFromFetchResult(result) {
  if (!result || typeof result !== "object") return {};
  const direct = result.revision;
  if (direct && typeof direct === "object" && Object.keys(direct).length > 0) {
    return direct;
  }
  const data = result.data;
  if (!data || typeof data !== "object") return {};
  const { revision } = normalizeDocumentRevisionInfoResponse(data);
  return revision && Object.keys(revision).length > 0
    ? revision
    : (data.documentRevision ?? data);
}

function parseIfsIdentifiersFromFileName(fileName) {
  if (!fileName) return {};
  const openParen = fileName.lastIndexOf("(");
  const closeParen = fileName.indexOf(")", openParen >= 0 ? openParen : 0);
  if (openParen < 0 || closeParen <= openParen) return {};
  const inside = fileName.slice(openParen + 1, closeParen).trim();
  if (!inside) return {};
  const parts = inside.split(" - ");
  if (parts.length < 4) return {};
  return {
    docClass: parts[0]?.trim(),
    docNo: parts[1]?.trim(),
    docSheet: parts[2]?.trim(),
    docRev: parts[3]?.trim(),
  };
}

function getWorkingFileMetaObject(file) {
  const rawMetaData = file?.MetaData ?? file?.metaData ?? file?.metadata;
  if (!rawMetaData) return null;
  if (typeof rawMetaData === "object") return rawMetaData;
  if (typeof rawMetaData !== "string") return null;
  try {
    return JSON.parse(rawMetaData);
  } catch (_err) {
    return null;
  }
}

function firstNonEmptyForCheckout(...values) {
  for (const value of values) {
    if (value == null) continue;
    const text = String(value).trim();
    if (text !== "") return text;
  }
  return "";
}

function buildCheckoutItemFromWorkingFile(file) {
  if (!file) return null;
  const meta = getWorkingFileMetaObject(file) ?? {};
  const fromName = parseIfsIdentifiersFromFileName(file?.name ?? "");

  const docClass = firstNonEmptyForCheckout(
    file?.docClass,
    file?.DocClass,
    meta?.docClass,
    meta?.DocClass,
    meta?.class,
    meta?.Class,
    fromName?.docClass,
  );
  const docNo = firstNonEmptyForCheckout(
    file?.docNo,
    file?.DocNo,
    meta?.docNo,
    meta?.DocNo,
    fromName?.docNo,
  );
  const docSheet = firstNonEmptyForCheckout(
    file?.docSheet,
    file?.DocSheet,
    file?.sheetNo,
    meta?.docSheet,
    meta?.DocSheet,
    meta?.sheetNo,
    fromName?.docSheet,
  );
  const docRev = firstNonEmptyForCheckout(
    file?.docRev,
    file?.DocRev,
    meta?.docRev,
    meta?.DocRev,
    fromName?.docRev,
  );

  if (!docClass || !docNo || !docRev) return null;

  const docType = firstNonEmptyForCheckout(
    meta?.docType,
    meta?.DocType,
    file?.docType,
    file?.DocType,
    "",
  );
  const fileNo =
    firstNonEmptyForCheckout(
      meta?.fileNo,
      meta?.FileNo,
      file?.fileNo,
      file?.FileNo,
      "1",
    ) || "1";
  const state = firstNonEmptyForCheckout(
    meta?.State,
    meta?.state,
    file?.State,
    file?.state,
    "",
  );
  const owner = firstNonEmptyForCheckout(
    meta?.Owner,
    meta?.owner,
    file?.Owner,
    file?.owner,
    file?.LastActionUser,
    file?.lastActionUser,
    "",
  );

  const title = getTitle(file?.name ?? "");
  const extFromName = (() => {
    const n = String(file?.name ?? "");
    const i = n.lastIndexOf(".");
    return i >= 0 ? n.slice(i + 1) : "";
  })();
  const fileExtension = firstNonEmptyForCheckout(
    meta?.fileExtension,
    meta?.FileExtension,
    extFromName,
    "",
  );
  const formatSizeCode = firstNonEmptyForCheckout(
    file?.formatSize,
    file?.FormatSize,
    file?.format,
    file?.Format,
    meta?.formatSize,
    meta?.FormatSize,
    meta?.format,
    meta?.Format,
    "",
  );

  return {
    class: getDocClassCodeOnly(docClass),
    docNo,
    sheetNo: docSheet || "",
    docRev,
    docType,
    fileNo,
    title,
    fileExtension,
    format: formatSizeCode,
    state,
    fileState: FILE_STATE.checkedOut,
    owner,
    isOneDriveDoc: false,
  };
}

function buildSelectedRevisionItemFromWorkingDocument(document) {
  const fromFile = buildCheckoutItemFromWorkingFile(document);
  if (fromFile?.class && fromFile?.docNo && fromFile?.docRev) {
    return {
      class: fromFile.class,
      docNo: fromFile.docNo,
      docRev: fromFile.docRev,
      sheetNo: fromFile.sheetNo ?? "",
      title:
        fromFile.title ||
        getTitle(document?.name ?? "") ||
        document?.name ||
        "",
      format: fromFile.format ?? "",
      documentNo: `${fromFile.docNo} - ${fromFile.docRev}`,
      fileExtension: fromFile.fileExtension ?? "",
    };
  }

  const revRows = getDocumentRevision(document?.name ?? "");
  const firstRev = revRows?.[0];
  if (!firstRev?.class || !firstRev?.docNo || !firstRev?.docRev) return null;

  return {
    class: firstRev.class,
    docNo: firstRev.docNo,
    docRev: firstRev.docRev,
    sheetNo: firstRev.sheetNo ?? "",
    title: getTitle(document?.name ?? "") || document?.name || "",
    format: firstRev.format ?? "",
    documentNo: `${firstRev.docNo} - ${firstRev.docRev}`,
    fileExtension: document?.name
      ? (String(document.name).split(".").pop() ?? "")
      : "",
  };
}

function isIfsRevisionCheckedOut(revision) {
  if (!revision || typeof revision !== "object") return false;
  const fs = revision.FileState ?? revision.fileState ?? "";
  if (fs === FILE_STATE.checkedOut) return true;
  const n = String(fs).trim().toLowerCase().replace(/\s+/g, " ");
  return n === "checked out" || n === "checked-out";
}

const WORKING_DOC_BATCH_SIZE = 20;
const WORKING_LIST_PAGE_SIZE = 20;
const WORKING_CARD_ROWS_PER_PAGE = 2;
const WORKING_CARD_PAGE_SIZE = 20;
/** Card pages to load up front so page 1–N do not wait on pagination load-more. */
const INITIAL_WORKING_DOC_CARD_PAGES_TO_PREFETCH = 4;

function getWorkingDocCardsPerRowFromViewport() {
  if (typeof window === "undefined") return 2;
  const w = window.innerWidth;
  if (w >= 1500) return 5;
  if (w >= 1200) return 4;
  if (w >= 768) return 3;
  return 1;
}

function getInitialWorkingDocumentFetchSize() {
  return WORKING_DOC_BATCH_SIZE;
}

function getContextMenuTypography(theme) {
  return {
    fontFamily: theme.contextMenu?.fontFamily ?? theme.fonts.regular,
    fontSize: theme.contextMenu?.fontSize ?? theme.fontSizes?.menusize ?? 12,
  };
}

const MENU_EVENT_STUB = {
  preventDefault: () => {},
  stopPropagation: () => {},
};

function buildWorkingRowMenuProps(theme, rawFile, actions) {
  const menuType = getContextMenuTypography(theme);
  const {
    onCheckIn,
    onOpenIFS,
    onEditInBrowser,
    onPreview,
    onDeleteFromOneDrive,
    onDetails,
  } = actions;

  return {
    shouldFocusOnMount: true,
    items: [
      {
        key: "checkIn",
        text: "Check-in",
        itemProps: {
          styles: {
            root: { color: theme.colors.fontColor, ...menuType },
          },
        },
        onClick: () => onCheckIn?.(rawFile),
      },
      {
        key: "openIfs",
        text: "Open in IFS Cloud",
        itemProps: {
          styles: {
            root: { color: theme.colors.fontColor, ...menuType },
          },
        },
        onClick: () => onOpenIFS?.(rawFile),
      },
      {
        key: "editBrowser",
        text: "Edit in Browser",
        itemProps: {
          styles: {
            root: { color: theme.colors.fontColor, ...menuType },
          },
        },
        onClick: () => onEditInBrowser?.(rawFile),
      },
      {
        key: "preview",
        text: "Preview in Teams",
        itemProps: {
          styles: {
            root: { color: theme.colors.fontColor, ...menuType },
          },
        },
        onClick: () => onPreview?.(rawFile),
      },
      {
        key: "deleteOneDrive",
        text: "Delete from OneDrive",
        itemProps: {
          styles: {
            root: { color: theme.colors.fontColor, ...menuType },
          },
        },
        onClick: () => onDeleteFromOneDrive?.(rawFile),
      },
      {
        key: "details",
        text: "Details",
        itemProps: {
          styles: {
            root: { color: theme.colors.fontColor, ...menuType },
          },
        },
        onClick: () => onDetails?.(rawFile),
      },
    ],
    styles: {
      root: {
        border: `1px solid ${theme.colors.addovation20Green} !important`,
        ...menuType,
        selectors: {
          ".ms-ContextualMenu-link:hover": {
            backgroundColor: theme.colors.contextMenuHover,
            color: theme.colors.fontColor,
          },
          ".ms-ContextualMenu-linkContent": {
            ...menuType,
          },
          ".ms-ContextualMenu-itemText": {
            ...menuType,
          },
          ".ms-FocusZone, .css-134, .ms-ContextualMenu, .is-open, .ms-BaseButton-menuhost":
            {
              backgroundColor: theme.colors.contextMenuBackground,
            },
        },
      },
    },
  };
}

const WorkingDocuments = ({
  isRefreshing,
  onRefresh,
  isPanelActive = true,
}) => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const skipInitialListLoadRef = useRef(
    Boolean(location.state?.[NAV_LOCATION_STATE.skipWorkingDocumentsRefresh]),
  );
  const theme = useTheme();
  const searchPanelStyle = useSearchPanel();

  const workingDoc = useWorkingDocument();
  const checkin = useCheckin();
  const metadata = useMetadata();
  const { teamsContext } = useLogin();
  const {
    tenantId: requestTenantId,
    groupId: requestGroupId,
    channelId: requestChannelId,
  } = useTeamsRequestContext();
  // General/common app has no live channel scope.
  const isGeneralAppContext = !teamsContext?.channel?.id;
  // Skip doc init API calls when channel has no configured IFS objects.
  const channelObjectList = useAppSelector(
    (state) => state.ChannelStore?.channelObjectList,
  );
  const channelConfigLoad = useAppSelector(
    (state) => state.ChannelStore?.channelConfigLoad,
  );
  const isChannelWithNoObjects =
    !isGeneralAppContext &&
    channelConfigLoad !== PROGRESS_STATUS.onStart &&
    (!channelObjectList || channelObjectList.length === 0);
  const effectiveTenantId = teamsContext?.user?.tenant?.id || requestTenantId;
  // In channel mode, prefer the live Teams context values (avoid stale local fallbacks).
  const effectiveChannelId = isGeneralAppContext
    ? ""
    : (teamsContext?.channel?.id ?? requestChannelId ?? "");
  const effectiveGroupId = isGeneralAppContext
    ? ""
    : teamsContext?.channel?.membershipType === "Private"
      ? (teamsContext?.channel?.ownerGroupId ?? requestGroupId ?? "")
      : (teamsContext?.team?.groupId ?? requestGroupId ?? "");
  const { ifsLatestDocument, filteredDocuments } = useDocuments();
  const checkout = useCheckout();
  const tools = useTools();
  const oneDrive = useOneDrive();
  const { state: previewState, previewInTeams } = usePreviewInTeams();
  const { state: uploadState } = useUploadToOneDrive();
  const {
    state: deleteState,
    deleteDocument: deleteWorkingDoc,
    clearState: clearDeleteState,
  } = useDeleteWorkingDocument();
  const {
    openInIFS,
    openIfsLoading,
    openIfsDialogOpen,
    openIfsDialogType,
    openIfsDialogTitle,
    openIfsDialogMessage,
    openIfsDialogDetails,
    closeOpenIfsDialog,
  } = useOpenInIFS();
  const {
    loading: checkinExistingFlowLoading,
    status: checkinExistingFlowStatus,
    message: checkinExistingFlowMessage,
    success: checkinExistingFlowSuccess,
    lastDocumentRevision,
    clear: clearCheckinExistingFlow,
  } = useCheckinExistingFlow();

  const {
    isListLoading,
    isListError,
    listError,
    list,
    listQuery,
    hasMoreServerDocuments,
    refreshTrigger,
    refreshWorkingDocuments,
    onWorkingDocumentLoad,
    loadMoreWorkingDocuments,
  } = workingDoc;
  // Slice is list-only; details/check-in state removed – use defaults so dialog and callbacks don’t break
  const workingDocumentListStatus = undefined;
  const workingDocumentStatus = undefined;
  const workingIfsDocument = {};
  const workingDocumentCheckinType = DOC_CHECK_IN_TYPE.checkinNewRevision;
  const workingDocument = {};
  const oneDriveDocumentDownloadUrl = null;
  const isDetailsLoading = false;
  const isDetailsError = false;
  const isDetailsNoData = true;
  const isDetailsComplete = false;
  const detailsTitleText = "";
  const getDetailsContentText = () => "";
  const {
    checkinExistingStatus,
    docReleaseStatus,
    createViewCopyDisable,
    createViewCopy,
    uploadFiles,
    viewCopyFiles,
    viewRequired,
    uploadViewCopyCount,
    isUploadDisabled,
    docClassFormatList,
    checkinExistingError,
    checkinExistingWarning,
    onCheckinExistingDocument,
    onCheckinViewCopy,
    onBasicDataLoad,
  } = checkin;
  const { loadIFSDocument, messageBoxInfo, tokenRefreshPreActionInvoke } =
    metadata;
  const {
    oneDriveUploadStatus,
    checkoutDocument: checkoutDocumentForRefresh,
    checkoutDocumentStatus,
    performCheckout,
    checkoutFlow,
  } = checkout;
  const checkoutUploadContext = useMemo(
    () =>
      effectiveTenantId != null
        ? {
            tenantId: effectiveTenantId,
            teamId: effectiveGroupId ?? "",
            channelId: effectiveChannelId ?? "",
            membershipType: teamsContext?.channel?.membershipType ?? "Regular",
            oneDriveRoot: effectiveChannelId ? "ChannelDoc" : "MainMenu",
          }
        : null,
    [
      effectiveTenantId,
      effectiveGroupId,
      effectiveChannelId,
      teamsContext?.channel?.membershipType,
    ],
  );
  const {
    checkinSuccess,
    checkinType,
    oneDriveDocumentId,
    oneDriveDeleteRequired,
  } = ifsLatestDocument || {};
  const enableSpinner = filteredDocuments?.enableSpinner;
  const {
    onContextualMenuDetailsClick,
    onDocTitleChange,
    onFileUploadChange,
    onCheckinPageNameChanged,
    onDocCheckinTypeChange,
    onBasicDataProgressChange,
    onObjectConnectionDataLoad,
    onNewRevisionInfoChange,
    onDocumentStorageModeChange,
    onTeamsFileSelectionChange,
    onSetDocumentToDeleteOneDrive,
    onAllowSelectionChange,
    onWorkingIfsDocumentChange,
    onWorkingDocumentCheckinTypeChange,
    onWorkingDocumentStatusChange,
    onWorkingDocumentListStatusChange,
    onErrorMessageInvoke,
    onExceptionMessageInvoke,
    onCheckinExistingStatusChange,
    onIfsDocumentLoadChange,
    onDocReleaseChange,
    onDocClassFormatListChange,
    onCreateViewCopySelect,
    onViewCopyUploadChange,
    onRefreshCheckinExisting,
    onRequestRefreshAllDocuments,
    onLoginRefreshPreActionClear,
    onSuccessMessageInvoke,
    onWorkingDocumentChange,
    onSelectedPageChange,
  } = tools;
  const { fetchOneDriveDownloadUrl: onDownLoadOneDriveDocument } = oneDrive;

  const onUploadWorkingDocument = (...args) =>
    dispatch(onUploadWorkingDocumentAction(...args));
  const onDocumentRevisionSearch = (...args) =>
    dispatch(onDocumentRevisionSearchAction(...args));
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedDocId, setSelectedDocId] = useState(null);
  const workingListMenuActionsRef = useRef({});
  const [selectedDocument, setSelectedDocument] = useState(null);
  const [open, setOpen] = useState(false);
  const [cardsPerRow, setCardsPerRow] = useState(2);
  const [isFetchingMore, setIsFetchingMore] = useState(false);
  const [deleteChkBox, setDeleteChkBox] = useState(
    new CustomerConfig().getIsOneDriveDocDeleteEnable(),
  );

  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [documentToDelete, setDocumentToDelete] = useState(null);
  /** When true, confirming delete runs undo check-out (IFS) instead of OneDrive-only delete. */
  const [pendingDeleteIsUndoCheckout, setPendingDeleteIsUndoCheckout] =
    useState(false);
  const [isDeleting, setIsDeleting] = useState(false);
  const [workingDocumentSearchText, setWorkingDocumentSearchText] =
    useState("");
  const [appliedWorkingSearchText, setAppliedWorkingSearchText] = useState("");
  const [workingDocumentFileType, setWorkingDocumentFileType] = useState(
    FILE_TYPES.allFiles,
  );
  const [isWorkingFilterVisible, setIsWorkingFilterVisible] = useState(false);
  const [workingViewMode, setWorkingViewMode] = useState("list");
  const [workingCardPageIndex, setWorkingCardPageIndex] = useState(0);
  const [workingListPageIndex, setWorkingListPageIndex] = useState(0);
  const [deleteError, setDeleteError] = useState(null);
  const [isDeleteAfterCheckinFlow, setIsDeleteAfterCheckinFlow] =
    useState(false);
  /** True while fetching latest IFS file status before Working Documents menu Check-in. */
  const [checkInStatusGateLoading, setCheckInStatusGateLoading] =
    useState(false);
  const [isCheckinMode, setIsCheckinMode] = useState(false);
  const hasHandledCheckinExistingSuccess = useRef(false);
  const prevCheckoutLoadingRef = useRef(false);
  const hasRefreshedForUndoCheckoutSuccess = useRef(false);
  const workingListSelection = useMemo(
    () =>
      new Selection({
        getKey: (item) => item.key,
      }),
    [],
  );

  const firstNonEmpty = (...values) => {
    for (const value of values) {
      if (value == null) continue;
      const text = String(value).trim();
      if (text !== "") return text;
    }
    return "";
  };

  const classFormatNameIndex = useMemo(() => {
    const index = new Map();
    if (!Array.isArray(docClassFormatList) || docClassFormatList.length === 0) {
      return index;
    }

    docClassFormatList.forEach((classItem) => {
      const classCode = firstNonEmpty(
        classItem?.docClass,
        classItem?.DocClass,
        classItem?.class,
        classItem?.Class,
      );
      if (!classCode) return;

      const formats = classItem?.formats ?? classItem?.Formats ?? [];
      if (!Array.isArray(formats)) return;

      formats.forEach((formatItem) => {
        const formatCode = firstNonEmpty(
          formatItem?.formatSize,
          formatItem?.FormatSize,
          formatItem?.format,
          formatItem?.Format,
        );
        const formatName = firstNonEmpty(
          formatItem?.formatSizeName,
          formatItem?.FormatSizeName,
          formatItem?.formatName,
          formatItem?.FormatName,
        );
        if (!formatCode || !formatName) return;
        const key = `${classCode}::${formatCode}`;
        if (!index.has(key)) {
          index.set(key, formatName);
        }
      });
    });

    return index;
  }, [docClassFormatList]);

  const getMetaDataObject = (file) => {
    const rawMetaData = file?.MetaData ?? file?.metaData ?? file?.metadata;
    if (!rawMetaData) return null;
    if (typeof rawMetaData === "object") return rawMetaData;
    if (typeof rawMetaData !== "string") return null;
    try {
      return JSON.parse(rawMetaData);
    } catch (_err) {
      return null;
    }
  };

  const getWorkingDocumentIdentifiers = (file) => {
    const metaData = getMetaDataObject(file) ?? {};
    const fromName = parseIfsIdentifiersFromFileName(file?.name ?? "");

    const docNo =
      firstNonEmpty(
        file?.docNo,
        file?.DocNo,
        metaData?.docNo,
        metaData?.DocNo,
        fromName?.docNo,
      ) || "";

    const docRev =
      firstNonEmpty(
        file?.docRev,
        file?.DocRev,
        metaData?.docRev,
        metaData?.DocRev,
        fromName?.docRev,
      ) || "";

    const docClassCode =
      firstNonEmpty(
        file?.docClass,
        file?.DocClass,
        file?.class,
        file?.Class,
        metaData?.docClass,
        metaData?.DocClass,
        metaData?.class,
        metaData?.Class,
        fromName?.docClass,
      ) || "";

    const formatSizeName =
      firstNonEmpty(
        file?.formatSizeName,
        file?.FormatSizeName,
        file?.formatName,
        file?.FormatName,
        metaData?.formatSizeName,
        metaData?.FormatSizeName,
        metaData?.formatName,
        metaData?.FormatName,
      ) || "";

    const formatSizeCode =
      firstNonEmpty(
        file?.formatSize,
        file?.FormatSize,
        file?.format,
        file?.Format,
        metaData?.formatSize,
        metaData?.FormatSize,
        metaData?.format,
        metaData?.Format,
      ) || "";

    const classDescription =
      firstNonEmpty(
        file?.docClassDescription,
        file?.DocClassDescription,
        file?.DocClassName,
        file?.docClassName,
        metaData?.docClassDescription,
        metaData?.DocClassDescription,
        metaData?.DocClassName,
        metaData?.docClassName,
      ) || "";

    const resolvedFormatName =
      formatSizeName ||
      (docClassCode && formatSizeCode
        ? (classFormatNameIndex.get(`${docClassCode}::${formatSizeCode}`) ?? "")
        : "");

    return {
      docNo,
      docRev,
      docClassCode,
      formatSizeName: resolvedFormatName,
      classDescription,
    };
  };

  let isOneDriveDocDeleteEnable =
    new CustomerConfig().getIsOneDriveDocDeleteEnable();
  const workingListPageSize = WORKING_LIST_PAGE_SIZE;

  useEffect(() => {
    if (isChannelWithNoObjects) return;
    if (Array.isArray(docClassFormatList) && docClassFormatList.length > 0) {
      return;
    }
    const loadBasicData = async () => {
      try {
        await onBasicDataLoad({
          retry: 0,
          actionType: REFRESH_TOKEN_ACTION.documentBasicInfoLoad,
          refreshResponse: RESPONSE_TYPE.none,
        });
      } catch (error) {
        console.error("Failed to load basic data:", error);
      }
    };

    loadBasicData();
    // eslint-disable-next-line react-hooks/exhaustive-deps -- load once when class/format tree is empty
  }, [docClassFormatList?.length]);

  useEffect(() => {
    if (triggerRefreshTokenPreAction(tokenRefreshPreActionInvoke) === true) {
      const run = async () => {
        switch (tokenRefreshPreActionInvoke.actionType) {
          case REFRESH_TOKEN_ACTION.documentBasicInfoLoad:
            await onBasicDataLoad(tokenRefreshPreActionInvoke);
            break;
          case REFRESH_TOKEN_ACTION.workingDocumentDetailsLoad:
            onDocumentRevisionSearch(
              selectedDocument,
              tokenRefreshPreActionInvoke,
            );
            break;
          case REFRESH_TOKEN_ACTION.checkinExisting:
            await _checkinExistingRevision(
              selectedDocument,
              oneDriveDocumentDownloadUrl,
              tokenRefreshPreActionInvoke,
            );
            break;
          case REFRESH_TOKEN_ACTION.checkinExistingViewCopy:
            await onCheckinViewCopy(
              workingIfsDocument.Title,
              workingIfsDocument.docClass,
              workingIfsDocument.docNo,
              workingIfsDocument.docSheet,
              workingIfsDocument.docRev,
              viewCopyFiles,
              viewRequired,
              docReleaseStatus,
              DOC_CHECK_IN_TYPE.checkinExisting,
              isDeleteWorkingDocument(),
              tokenRefreshPreActionInvoke,
              REFRESH_TOKEN_ACTION.checkinExistingViewCopy,
            );
            break;
          default:
            break;
        }
      };

      run();
    }
  }, [tokenRefreshPreActionInvoke]);

  useEffect(() => {
    if (docClassFormatList && Array.isArray(docClassFormatList)) {
    }
  }, [docClassFormatList]);

  // List load for both channel and general contexts (server-side search + file type).
  useEffect(() => {
    if (isChannelWithNoObjects) return;
    if (!isPanelActive) return;
    if (skipInitialListLoadRef.current) {
      skipInitialListLoadRef.current = false;
      navigate(location.pathname, { replace: true, state: {} });
      return;
    }
    if (!effectiveTenantId) {
      onWorkingDocumentListStatusChange(DOCUMENT_LOAD_STATUS.noData);
      return;
    }
    // After check-out/download from All Documents, a dedicated effect refetches the list.
    if (location.state?.[NAV_LOCATION_STATE.forceRefreshWorkingDocuments]) {
      return;
    }
    const apiFileType =
      workingDocumentFileType && workingDocumentFileType !== FILE_TYPES.allFiles
        ? workingDocumentFileType
        : "''";
    const queryMatches =
      (listQuery?.searchText ?? "") === (appliedWorkingSearchText ?? "") &&
      (listQuery?.fileType ?? "''") === apiFileType;
    const hasCachedList =
      Array.isArray(list) && list.length > 0 && !isListLoading && queryMatches;
    if (hasCachedList) {
      return;
    }
    loadWorkingDocuments();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    isPanelActive,
    effectiveTenantId,
    effectiveChannelId,
    appliedWorkingSearchText,
    workingDocumentFileType,
  ]);

  useEffect(() => {
    const calculateCardsPerRow = () => {
      const screenWidth = window.innerWidth;
      if (screenWidth >= 1500) return 5;
      if (screenWidth >= 1200) return 4;
      if (screenWidth >= 768) return 3;
      return 1;
    };

    const handleResize = () => {
      const newCardsPerRow = calculateCardsPerRow();
      setCardsPerRow(newCardsPerRow);
    };

    handleResize();

    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function triggerRefreshTokenPreAction(tokenRefreshPreActionInvoke) {
    if (isValidPlayload(tokenRefreshPreActionInvoke)) {
      return (
        tokenRefreshPreActionInvoke.actionType ===
          REFRESH_TOKEN_ACTION.documentBasicInfoLoad ||
        tokenRefreshPreActionInvoke.actionType ===
          REFRESH_TOKEN_ACTION.workingDocumentDetailsLoad ||
        tokenRefreshPreActionInvoke.actionType ===
          REFRESH_TOKEN_ACTION.checkinExisting ||
        tokenRefreshPreActionInvoke.actionType ===
          REFRESH_TOKEN_ACTION.checkinExistingViewCopy
      );
    }

    return false;
  }

  const handleRefreshDocuments = useCallback(async () => {
    setIsFetchingMore(false);
    const fileRoot = isGeneralAppContext ? "/MainMenu" : "/ChannelDoc";
    const initialSize = getInitialWorkingDocumentFetchSize();
    const currentlyLoadedCount = Array.isArray(list) ? list.length : 0;
    // Manual refresh should not shrink the already loaded list.
    const refreshSize = Math.max(initialSize, currentlyLoadedCount);
    const apiFileType =
      workingDocumentFileType && workingDocumentFileType !== FILE_TYPES.allFiles
        ? workingDocumentFileType
        : "''";
    await onWorkingDocumentLoad(
      effectiveGroupId,
      effectiveChannelId,
      effectiveTenantId,
      fileRoot,
      refreshSize,
      {
        recFrom: 0,
        recSize: refreshSize,
        searchText: appliedWorkingSearchText,
        fileType: apiFileType,
      },
    );
    // hasMoreServerDocuments is updated in workingDocumentSlice on fetch fulfillment.
  }, [
    onWorkingDocumentLoad,
    effectiveGroupId,
    effectiveChannelId,
    effectiveTenantId,
    isGeneralAppContext,
    appliedWorkingSearchText,
    workingDocumentFileType,
    list,
  ]);

  useEffect(() => {
    if (checkoutDocumentStatus === DOCUMENT_LOAD_STATUS.onUploadError) {
      performCheckout(
        checkoutDocumentForRefresh,
        tokenRefreshPreActionInvoke,
        true,
      );
    }
  }, [
    checkoutDocumentStatus,
    checkoutDocumentForRefresh,
    performCheckout,
    tokenRefreshPreActionInvoke,
  ]);

  useEffect(() => {
    const justFinishedCheckoutOperation =
      prevCheckoutLoadingRef.current && !checkoutFlow?.loading;
    const isUndoCheckoutSuccess =
      justFinishedCheckoutOperation &&
      !checkoutFlow?.loading &&
      checkoutFlow?.dialogVariant === "info" &&
      checkoutFlow?.lastOperationWasCheckout === false;
    if (isUndoCheckoutSuccess && !hasRefreshedForUndoCheckoutSuccess.current) {
      hasRefreshedForUndoCheckoutSuccess.current = true;
      void handleRefreshDocuments();
      onWorkingDocumentListStatusChange(DOCUMENT_LOAD_STATUS.onRefresh);
    }
    if (checkoutFlow?.loading) {
      hasRefreshedForUndoCheckoutSuccess.current = false;
    }
    prevCheckoutLoadingRef.current = Boolean(checkoutFlow?.loading);
  }, [
    checkoutFlow?.loading,
    checkoutFlow?.dialogVariant,
    checkoutFlow?.lastOperationWasCheckout,
    handleRefreshDocuments,
    onWorkingDocumentListStatusChange,
  ]);

  useEffect(() => {
    if (!isValidPlayload(tokenRefreshPreActionInvoke)) return;
    if (
      tokenRefreshPreActionInvoke.actionType !==
      REFRESH_TOKEN_ACTION.documentCheckoutLoad
    ) {
      return;
    }
    performCheckout(
      checkoutDocumentForRefresh,
      tokenRefreshPreActionInvoke,
      false,
      checkoutUploadContext ?? undefined,
    );
  }, [
    tokenRefreshPreActionInvoke,
    checkoutDocumentForRefresh,
    performCheckout,
    checkoutUploadContext,
  ]);

  useEffect(() => {
    if (!isRefreshing) return;
    let cancelled = false;
    handleRefreshDocuments()
      .then(() => {
        if (!cancelled) onRefresh?.();
      })
      .catch(() => {
        if (!cancelled) onRefresh?.();
      });
    return () => {
      cancelled = true;
    };
  }, [isRefreshing, handleRefreshDocuments, onRefresh]);

  useEffect(() => {
    if (oneDriveUploadStatus !== DATA_LOAD_STATUS.completed) return;
    if (!isPanelActive) return;
    (async () => {
      await loadWorkingDocuments();
    })();
  }, [
    oneDriveUploadStatus,
    effectiveTenantId,
    effectiveChannelId,
    isPanelActive,
  ]);

  useEffect(() => {
    if (workingDocumentCheckinType === DOC_CHECK_IN_TYPE.checkinExisting) {
      const run = async () => {
        switch (checkinExistingStatus) {
          case DOCUMENT_LOAD_STATUS.onDownloading:
            setIsDeleteAfterCheckinFlow(false);
            onWorkingDocumentStatusChange(DOCUMENT_LOAD_STATUS.onDownloading);
            break;
          case DOCUMENT_LOAD_STATUS.onUploading:
            onWorkingDocumentStatusChange(DOCUMENT_LOAD_STATUS.onUploading);
            await _checkinExistingRevision(
              selectedDocument,
              oneDriveDocumentDownloadUrl,
              {
                retry: 0,
                actionType: REFRESH_TOKEN_ACTION.checkinExisting,
                refreshResponse: RESPONSE_TYPE.none,
              },
            );
            break;
          case DOCUMENT_LOAD_STATUS.onUpdating:
            onWorkingDocumentStatusChange(DOCUMENT_LOAD_STATUS.onUpdating);
            await _updateWorkingDocument();
            break;
          case DOCUMENT_LOAD_STATUS.onViewCopyUpload:
            if (uploadViewCopyCount > 0) {
              await onCheckinViewCopy(
                workingIfsDocument.Title,
                workingIfsDocument.docClass,
                workingIfsDocument.docNo,
                workingIfsDocument.docSheet,
                workingIfsDocument.docRev,
                viewCopyFiles,
                viewRequired,
                docReleaseStatus,
                DOC_CHECK_IN_TYPE.checkinExisting,
                isDeleteWorkingDocument(),
                {
                  retry: 0,
                  actionType: REFRESH_TOKEN_ACTION.checkinExistingViewCopy,
                  refreshResponse: RESPONSE_TYPE.none,
                },
                REFRESH_TOKEN_ACTION.checkinExistingViewCopy,
              );
            }
            break;
          case DOCUMENT_LOAD_STATUS.onCompletion:
            if (workingDocument) {
              let displayTitle =
                workingDocument?.title || workingDocument?.name || "Document";
              try {
                displayTitle = decodeURIComponent(displayTitle);
              } catch (_err) {
                // Keep original title when it's not URI encoded.
              }
              let successMessage = getSuccessMessage(
                CHECKIN_SUCCESS_TITLE,
                DocumentCheckin(displayTitle),
              );
              onIfsDocumentLoadChange(DATA_LOAD_STATUS.onLoad);
              onSuccessMessageInvoke(successMessage);
              navigate(APP_ROUTES.allDocuments);
            }
            setIsDeleteAfterCheckinFlow(false);
            onWorkingDocumentCheckinTypeChange(DOCUMENT_LOAD_STATUS.onStart);
            await loadWorkingDocuments();
            break;
          case DOCUMENT_LOAD_STATUS.onError:
          case DOCUMENT_LOAD_STATUS.noData:
            setIsDeleteAfterCheckinFlow(false);
            handleClose();
            onWorkingDocumentCheckinTypeChange(DOCUMENT_LOAD_STATUS.onStart);
            break;
          case DOCUMENT_LOAD_STATUS.onUnauthorized:
            onWorkingDocumentStatusChange(DOCUMENT_LOAD_STATUS.onCompletion);
            break;
          default:
            console.log(
              "No action for loading status: " + checkinExistingStatus,
            );
            break;
        }
      };
      run();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [checkinExistingStatus]);

  const filesData = list;
  const getWorkingFileTypeFromName = useCallback((name) => {
    const ext = String(name ?? "")
      .split(".")
      .pop()
      .toLowerCase();
    if (
      ["doc", "docx", "docm", "dot", "dotm", "dotx", "rtf", "odt"].includes(ext)
    ) {
      return FILE_TYPES.docx;
    }
    if (
      [
        "xls",
        "xlsx",
        "xlsm",
        "csv",
        "xlsb",
        "ods",
        "xlt",
        "xltx",
        "xltm",
      ].includes(ext)
    ) {
      return FILE_TYPES.xlsx;
    }
    if (
      [
        "ppt",
        "pptx",
        "pptm",
        "potm",
        "potx",
        "pps",
        "ppsx",
        "ppsm",
        "pot",
      ].includes(ext)
    ) {
      return FILE_TYPES.pptx;
    }
    if (ext === "pdf") {
      return FILE_TYPES.pdf;
    }
    return FILE_TYPES.allFiles;
  }, []);
  const visibleFilesData = useMemo(() => filesData, [filesData]);

  useEffect(() => {
    if (!Array.isArray(filesData) || filesData.length === 0) return;

    const typeSummary = filesData.map((file) => ({
      id: file?.id,
      name: file?.name,
      extension:
        String(file?.name ?? "")
          .split(".")
          .pop()
          ?.toLowerCase() ?? "",
      mimeType: file?.file?.mimeType ?? file?.mimeType ?? "",
      groupedType: getWorkingFileTypeFromName(file?.name),
      status: file?.status ?? file?.Status ?? "",
      fileState: file?.fileState ?? file?.FileState ?? "",
      lastAction: file?.lastAction ?? file?.LastAction ?? "",
      metaData: file?.MetaData ?? file?.metaData ?? file?.metadata ?? null,
    }));

    //console.log("[WorkingDocuments] OneDrive document types", typeSummary);
    /*console.table(
      typeSummary.map((item) => ({
        id: item.id,
        name: item.name,
        fileState: item.fileState,
        status: item.status,
        lastAction: item.lastAction,
      })),
    );*/
  }, [filesData, getWorkingFileTypeFromName]);

  const isWorkingListView = workingViewMode === "list";
  const workingCardPageSize = WORKING_CARD_PAGE_SIZE;
  const cardPageStart = workingCardPageIndex * workingCardPageSize;
  const cardDisplayedFiles = visibleFilesData.slice(
    cardPageStart,
    cardPageStart + workingCardPageSize,
  );
  const listPageStart = workingListPageIndex * workingListPageSize;
  const listDisplayedFiles = visibleFilesData.slice(
    listPageStart,
    listPageStart + workingListPageSize,
  );

  const workingCardHasNext =
    cardDisplayedFiles.length >= workingCardPageSize &&
    (cardPageStart + workingCardPageSize < visibleFilesData.length ||
      hasMoreServerDocuments);
  const workingListHasNext =
    listDisplayedFiles.length >= workingListPageSize &&
    (listPageStart + workingListPageSize < visibleFilesData.length ||
      hasMoreServerDocuments);
  const workingListItems = useMemo(
    () =>
      listDisplayedFiles.map((file) => {
        const identifiers = getWorkingDocumentIdentifiers(file);
        const meta = getMetaDataObject(file) ?? {};
        const lastActionInfo = resolveLastAction({
          ...file,
          latestHistory:
            file.latestHistory ?? file.LatestHistory ?? meta.latestHistory,
          LastAction:
            file.LastAction ??
            file.lastAction ??
            meta.LastAction ??
            meta.lastAction,
          LastActionDate:
            firstNonEmpty(
              meta.LastActionDate,
              meta.lastActionDate,
              file.LastActionDate,
              file.lastActionDate,
            ) || file.lastModifiedDateTime,
          LastActionUser: file.LastActionUser ?? meta.Owner ?? meta.owner,
          DtChg: file.DtChg ?? file.lastModifiedDateTime,
          LatestHandling: file.LatestHandling ?? file.lastModifiedDateTime,
          DocRespName: file.DocRespName ?? meta.Owner ?? meta.owner,
        });
        const classText = [
          file.DocClass ?? file.docClass,
          file.DocClassName ?? file.docClassName,
        ]
          .map((v) => (v ?? "").toString().trim())
          .filter(Boolean)
          .join(" - ");
        const formatText = [
          file.FormatSize ?? file.formatSize,
          file.FormatSizeName ?? file.formatSizeName,
        ]
          .map((v) => (v ?? "").toString().trim())
          .filter(Boolean)
          .join(" - ");
        const stateText = meta.State ?? meta.state ?? "";
        const tooltipContent = [
          `Title: ${getTitle(file.name ?? "")}`,
          `Document No: ${identifiers.docNo ?? ""} - ${identifiers.docRev ?? ""}`,
          classText ? `Class: ${classText}` : "",
          formatText ? `Format: ${formatText}` : "",
          stateText ? `State: ${stateText}` : "",
          lastActionInfo.display ? `Modified: ${lastActionInfo.display}` : "",
          getWorkingDocumentEditedLabel(file),
        ].filter(Boolean);
        const activityUser =
          file.lastModifiedBy?.user?.displayName ||
          file.lastModifiedBy?.displayName ||
          file.ModifiedBy ||
          file.modifiedBy ||
          "";
        const modifiedDateTime =
          file.lastModifiedDateTime ||
          file.modifiedDateTime ||
          "";
        const activityRelativeTime = modifiedDateTime
          ? getRelativeTime(modifiedDateTime, {
              long: true,
              dayAsRelative: true,
              dayDiffMode: "calendar",
              timeZoneMode: "utc",
              monthFormat: "long",
            })
          : "-";
        const modifiedTooltip = modifiedDateTime
          ? getRelativeTimeTooltip(modifiedDateTime, {
              timeZoneMode: "local",
            })
          : "";
        return {
          key: file.id || file.name,
          rawFile: file,
          title: getTitle(file.name ?? ""),
          iconName: getDocIcon(
            file.name,
            isWorkingDocumentCheckedOut(file),
            "default",
            isDocumentReleased(file),
          ),
          tooltipContent,
          lastActionDate: lastActionInfo.display,
          lastActionTimestamp: lastActionInfo.timestamp,
          modified: activityRelativeTime,
          modifiedTooltip,
          modifiedBy: activityUser || "-",
          docNo: identifiers.docNo,
          docRev: identifiers.docRev,
          class: getDocumentClassFormatLabel(
            identifiers.docClassCode,
            identifiers.formatSizeName,
          ),
          className: identifiers.classDescription,
        };
      }),
    [listDisplayedFiles],
  );
  const handleUndoCheckoutFromWorkingFile = useCallback(
    (document, flowOptions = {}) => {
      const checkoutItem = buildCheckoutItemFromWorkingFile(document);
      if (!checkoutItem) {
        onErrorMessageInvoke({
          type: ERROR_TYPE,
          message: UNDOCHECKOUT_NOT_FOUND,
          errorMessage: "",
          error: null,
        });
        return undefined;
      }
      dispatch({
        type: ON_CHECKOUT_DOCUMENT_CHANGE,
        payload: checkoutItem,
      });
      return performCheckout(
        checkoutItem,
        undefined,
        false,
        checkoutUploadContext ?? undefined,
        flowOptions,
      );
    },
    [dispatch, onErrorMessageInvoke, performCheckout, checkoutUploadContext],
  );
  const workingListColumns = useMemo(
    () => [
      {
        key: "rowOffsetSpacer",
        name: "",
        fieldName: "__rowOffsetSpacer",
        minWidth: 36,
        maxWidth: 36,
        isResizable: false,
        onRender: () => null,
      },
      {
        key: "fileType",
        fieldName: "iconName",
        minWidth: 16,
        maxWidth: 16,
        onRender: (item) => (
          <DocIconTooltip
            content={item.tooltipContent}
            listType="div"
            position="right"
            maxWidth={260}
            delay={100}
          >
            <img
              src={item.iconName}
              style={{ width: 16, height: 16, objectFit: "contain" }}
              alt="file icon"
            />
          </DocIconTooltip>
        ),
      },
      {
        key: "docNo",
        name: "Document No",
        minWidth: 110,
        maxWidth: 110,
        isResizable: true,
        onRender: (item) => (
          <span
            onClick={(ev) => {
              ev.preventDefault();
              ev.stopPropagation();
              openInIFS(item.rawFile);
            }}
            style={{
              cursor: "pointer",
              textDecoration: "underline",
              color: theme.colors.themeDarkColor ?? "#249f5d",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          >
            {item.docRev ? `${item.docNo ?? ""} - ${item.docRev}` : item.docNo}
          </span>
        ),
      },
      {
        key: "title",
        name: "Title",
        fieldName: "title",
        minWidth: 340,
        maxWidth: 340,
        isResizable: true,
        onRender: (item) => (
          <div
            style={{
              width: "100%",
              overflow: "hidden",
            }}
          >
            <span
              style={{
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                display: "block",
                width: "100%",
                minWidth: 0,
              }}
            >
              {item.title}
            </span>
          </div>
        ),
      },
      {
        key: "documentAndOptions",
        name: "",
        minWidth: 30,
        maxWidth: 30,
        isResizable: false,
        onRender: (item) => (
          <div
            style={{
              display: "flex",
              width: "100%",
              height: "100%",
              maxWidth: "100%",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <IconButton
              menuProps={buildWorkingRowMenuProps(
                theme,
                item.rawFile,
                workingListMenuActionsRef.current,
              )}
              menuIconProps={{ iconName: "More" }}
              title="More actions"
              styles={{
                root: {
                  color: theme.colors.themeDarkColor,
                  fontFamily: `${theme.fonts.regular}`,
                  fontSize: theme.fontSizes.medium,
                  minHeight: 0,
                  height: "100%",
                  padding: 0,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  selectors: {
                    ".ms-ContextualMenu-itemText": {
                      ...getContextMenuTypography(theme),
                      backgroundColor: theme.colors.msTeamsFilesHover,
                    },
                    ".ms-ContextualMenu-linkContent": {
                      ...getContextMenuTypography(theme),
                      backgroundColor: theme.colors.msTeamsFilesHover,
                    },
                  },
                },
              }}
            />
          </div>
        ),
      },
      {
        key: "class",
        name: "Class/Format",
        minWidth: 160,
        maxWidth: 160,
        isResizable: true,
        onRender: (item) => (
          <span
            style={{
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              display: "inline-block",
              maxWidth: "100%",
            }}
          >
            {item.class}
          </span>
        ),
      },
      {
        key: "modified",
        name: "Modified",
        fieldName: "modified",
        minWidth: 130,
        maxWidth: 150,
        isResizable: true,
        onRender: (item) => (
          <DocIconTooltip
            content={item.modifiedTooltip}
            listType="div"
            position="top"
            maxWidth={340}
            delay={100}
            disabled={!item.modifiedTooltip}
          >
            <span
              style={{
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                display: "inline-block",
                maxWidth: "100%",
              }}
            >
              {item.modified}
            </span>
          </DocIconTooltip>
        ),
      },
      {
        key: "modifiedBy",
        name: "Modified By",
        fieldName: "modifiedBy",
        minWidth: 170,
        maxWidth: 220,
        isResizable: true,
        onRender: (item) => (
          <span
            style={{
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              display: "inline-block",
              maxWidth: "100%",
            }}
          >
            {item.modifiedBy}
          </span>
        ),
      },
    ],
    [theme, openInIFS],
  );
  const workingVisibleListColumns = useMemo(
    () => workingListColumns.filter((col) => col?.isHidden !== true),
    [workingListColumns],
  );
  useEffect(() => {
    setWorkingCardPageIndex(0);
    setWorkingListPageIndex(0);
  }, [appliedWorkingSearchText, workingViewMode, workingDocumentFileType]);

  const renderWorkingFilterButton = useCallback(
    (fileType, label, icon) => {
      const isSelected = workingDocumentFileType === fileType;
      const disabled = isListLoading;
      const containerStyle = {
        ...(isSelected
          ? searchPanelStyle.FileTypeButtonContainerSelectedStyle
          : searchPanelStyle.FileTypeButtonContainerStyle),
        ...(disabled && { pointerEvents: "none", opacity: 0.6 }),
      };
      return (
        <div
          key={fileType || "all-files"}
          style={containerStyle}
          onClick={() => !disabled && setWorkingDocumentFileType(fileType)}
          role="button"
          tabIndex={disabled ? -1 : 0}
          onKeyDown={(e) => {
            if (!disabled && e.key === "Enter")
              setWorkingDocumentFileType(fileType);
          }}
          aria-disabled={disabled}
        >
          <button
            type="button"
            disabled={disabled}
            onClick={() => !disabled && setWorkingDocumentFileType(fileType)}
            style={searchPanelStyle.FileTypeButtonStyle}
          >
            {icon}
            <span style={searchPanelStyle.FileTypeTextStyle}>{label}</span>
          </button>
        </div>
      );
    },
    [searchPanelStyle, workingDocumentFileType, isListLoading],
  );

  const workingFilterContent = useMemo(
    () => (
      <>
        {renderWorkingFilterButton(FILE_TYPES.allFiles, "All Files", null)}
        {renderWorkingFilterButton(
          FILE_TYPES.docx,
          "Word",
          <img
            src={wordFilterIcon}
            alt="Word"
            style={searchPanelStyle.IconImageStyle}
          />,
        )}
        {renderWorkingFilterButton(
          FILE_TYPES.xlsx,
          "Excel",
          <img
            src={excelFilterIcon}
            alt="Excel"
            style={searchPanelStyle.IconImageStyle}
          />,
        )}
        {renderWorkingFilterButton(
          FILE_TYPES.pptx,
          "PowerPoint",
          <img
            src={powerpointFilterIcon}
            alt="PowerPoint"
            style={searchPanelStyle.IconImageStyle}
          />,
        )}
        {renderWorkingFilterButton(
          FILE_TYPES.pdf,
          "PDF",
          <img
            src={pdfFilterIcon}
            alt="PDF"
            style={searchPanelStyle.PdfFilterIconImageStyle}
          />,
        )}
      </>
    ),
    [renderWorkingFilterButton, searchPanelStyle],
  );

  useEffect(() => {
    const n = visibleFilesData.length;
    if (n === 0) {
      if (workingListPageIndex !== 0) setWorkingListPageIndex(0);
      if (workingCardPageIndex !== 0) setWorkingCardPageIndex(0);
    }
  }, [visibleFilesData.length, workingListPageIndex, workingCardPageIndex]);

  const loaderBorderStyle = {
    padding: "10px auto",
    bottom: "50px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100%",
  };

  const isDarkMode =
    String(theme.colors.pureColor || "").toLowerCase() === "#000000";
  const scrollbarTrack =
    theme.colors.scrollbarBackground ?? (isDarkMode ? "#525252" : "#fff");
  const scrollbarThumb =
    theme.colors.scrollbarThumb ?? (isDarkMode ? "#848484" : "#ccc");
  const sbWidth = 10;
  const sbHeight = 10;
  const workingDocumentsScrollStyles = {
    scrollbarWidth: "thin",
    scrollbarColor: `${scrollbarThumb} ${scrollbarTrack}`,
    "&::-webkit-scrollbar": {
      width: sbWidth,
      height: sbHeight,
      display: "block",
    },
    "&::-webkit-scrollbar-track": {
      background: scrollbarTrack,
    },
    "&::-webkit-scrollbar-thumb": {
      background: scrollbarThumb,
      borderRadius: sbWidth,
      border: `2px solid ${scrollbarTrack}`,
      minHeight: 40,
    },
    "&::-webkit-scrollbar-thumb:hover": {
      background: isDarkMode ? "#9a9a9a" : "#b3b3b3",
    },
    "&::-webkit-scrollbar-button": {
      display: "none",
      height: 0,
      width: 0,
    },
  };

  const loadWorkingDocuments = async (overrides = {}) => {
    if (!effectiveTenantId) {
      onWorkingDocumentListStatusChange(DOCUMENT_LOAD_STATUS.noData);
      return;
    }
    // Reset paging when refreshing the working document list.
    setWorkingCardPageIndex(0);
    setWorkingListPageIndex(0);
    setIsFetchingMore(false);
    logger.debug(
      "WorkingDocuments loadWorkingDocuments -> forcing handleClose before refresh",
      {
        open,
        listStatus: workingDocumentListStatus,
      },
      "DIALOG",
    );
    handleClose();
    const fileRoot = isGeneralAppContext ? "/MainMenu" : "/ChannelDoc";
    const initialSize = getInitialWorkingDocumentFetchSize();
    const apiFileType =
      workingDocumentFileType && workingDocumentFileType !== FILE_TYPES.allFiles
        ? workingDocumentFileType
        : "''";
    const searchText =
      overrides.searchText !== undefined
        ? overrides.searchText
        : appliedWorkingSearchText;
    const fileType =
      overrides.fileType !== undefined ? overrides.fileType : apiFileType;
    await onWorkingDocumentLoad(
      effectiveGroupId,
      effectiveChannelId,
      effectiveTenantId,
      fileRoot,
      initialSize,
      {
        recFrom: 0,
        recSize: initialSize,
        searchText,
        fileType,
      },
    );
    // hasMoreServerDocuments is updated in workingDocumentSlice on fetch fulfillment.
  };

  // Refetch when sidebar/accordion requests refresh (same pattern as All Documents refreshTrigger).
  useEffect(() => {
    if (!refreshTrigger) return;
    if (!effectiveTenantId) return;
    if (!isPanelActive) return;
    void loadWorkingDocuments();
    // eslint-disable-next-line react-hooks/exhaustive-deps -- loadWorkingDocuments is intentionally omitted
  }, [refreshTrigger, effectiveTenantId, isPanelActive]);

  // After check-out/download from All Documents: force one list fetch via router state.
  useEffect(() => {
    const shouldForceRefresh = Boolean(
      location.state?.[NAV_LOCATION_STATE.forceRefreshWorkingDocuments],
    );
    if (!shouldForceRefresh) return;

    navigate(location.pathname, { replace: true, state: {} });
    if (!effectiveTenantId) return;
    void loadWorkingDocuments();
    // eslint-disable-next-line react-hooks/exhaustive-deps -- loadWorkingDocuments is intentionally omitted
  }, [
    location.state?.[NAV_LOCATION_STATE.forceRefreshWorkingDocuments],
    location.pathname,
    effectiveTenantId,
    navigate,
  ]);

  const handleDeleteDialogClose = () => {
    setDeleteDialogOpen(false);
    setDocumentToDelete(null);
    setDeleteError(null);
    setIsDeleting(false);
    setPendingDeleteIsUndoCheckout(false);
  };

  const handleConfirmDelete = async () => {
    if (!documentToDelete) return;
    const doc = documentToDelete;
    const isUndo = pendingDeleteIsUndoCheckout;

    if (isUndo) {
      setDeleteDialogOpen(false);
      setDocumentToDelete(null);
      setDeleteError(null);
      setPendingDeleteIsUndoCheckout(false);
      const action = handleUndoCheckoutFromWorkingFile(doc, {
        progressMessage: UNDO_CHECKOUT_DELETE_PENDING,
        suppressSuccessToast: true,
      });
      if (action == null || typeof action.unwrap !== "function") {
        return;
      }
      try {
        await action.unwrap();
        void handleRefreshDocuments();
        onWorkingDocumentListStatusChange(DOCUMENT_LOAD_STATUS.onRefresh);
      } catch (_err) {
        // Errors surfaced via checkout slice / toastMiddleware
      }
      return;
    }

    setDeleteDialogOpen(false);
    setDocumentToDelete(null);
    setDeleteError(null);
    setPendingDeleteIsUndoCheckout(false);
    deleteWorkingDoc(doc).catch(() => {
      // Error shown in ReusableMessageDialog from slice state
    });
  };

  // Refresh list as soon as delete succeeds (dialog auto-closes after 3s via slice)
  useEffect(() => {
    if (!deleteState?.success) return;
    handleRefreshDocuments();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [deleteState?.success]);

  const handleMenuOpen = (event, docId, document) => {
    setAnchorEl(event.currentTarget);
    setSelectedDocId(docId);
    setSelectedDocument(document);
    event.stopPropagation();
  };

  const handleMenuClose = (event) => {
    setAnchorEl(null);
    setSelectedDocId(null);
    setSelectedDocument(null);
    event.stopPropagation();
  };

  /** "Delete from OneDrive": same confirm for all; on confirm runs undo check-out when checked out, else OneDrive delete. */
  function handleDeleteFromOneDrive(ev, document) {
    if (!document || !ev) return;
    ev.preventDefault();
    ev.stopPropagation();
    setPendingDeleteIsUndoCheckout(isWorkingDocumentCheckedOut(document));
    setDocumentToDelete(document);
    setDeleteError(null);
    handleMenuClose(ev);
    setTimeout(() => setDeleteDialogOpen(true), 0);
  }

  const handleCheckIn = async (
    checkInType,
    document,
    deleteRequired = false,
    workingIfsDocumentDetails = null,
  ) => {
    if (!document) return;

    let title = getFileName(document.name);
    let fileName = document.name;

    onDocTitleChange(title);
    if (checkInType === DOC_CHECK_IN_TYPE.checkinExisting) {
      onWorkingDocumentCheckinTypeChange(checkInType);
      await _onDownloadUrl(document);
    } else {
      const allFiles = [
        {
          name: fileName,
          type: document.file?.mimeType || "",
          size: "0 KB",
          base64: "",
          base64str: "",
          ...(checkInType === DOC_CHECK_IN_TYPE.checkinExisting && {
            docClass: "",
            docNo: "",
            docRev: "",
            docSheet: "",
            docType: "",
          }),
        },
      ];

      onFileUploadChange(allFiles, allFiles.length);
      let url = await getDownloadUrl(document.id);
      onTeamsFileSelectionChange([
        {
          key: document.id,
          name: document.name,
          documentMode: DOCUMENT_MODE.oneDrive,
          downloadlink: url,
          fileType: document.file?.mimeType || "",
          weblink: document.webUrl,
        },
      ]);

      switch (checkInType) {
        case CHECKIN_NEW:
          onDocCheckinTypeChange(CHECKIN_NEW);
          onSelectedPageChange(PAGE_NAME.checkInFromTeams);
          onCheckinPageNameChanged(CHECKIN_NEW_PAGE_NAME.basic);
          onBasicDataProgressChange(DATA_LOAD_STATUS.onLoad);
          navigate(APP_ROUTES.checkInNewForm, {
            state: {
              selectedDocument: {
                // `CheckInNew` expects `selectedDocument.key` when it needs to resolve
                // a download URL during submission.
                key: document.id,
                name: document.name,
                fileType: document.file?.mimeType || "",
              },
              // `CheckInNew` prefers this over Redux fallback URLs.
              selectedDocumentDownloadUrl: url,
              from: APP_ROUTES.workingDocuments,
            },
          });
          break;
        case CHECKIN_NEW_REVISION:
          onDocCheckinTypeChange(CHECKIN_NEW_REVISION);
          onNewRevisionInfoChange(DATA_LOAD_STATUS.refresh);
          onSelectedPageChange(PAGE_NAME.checkInNewRevision);

          const docClass =
            workingIfsDocumentDetails?.docClass ??
            workingIfsDocumentDetails?.class ??
            workingIfsDocumentDetails?.DocClass ??
            "";
          const docNo =
            workingIfsDocumentDetails?.docNo ??
            workingIfsDocumentDetails?.DocNo ??
            "";
          const docRev =
            workingIfsDocumentDetails?.docRev ??
            workingIfsDocumentDetails?.DocRev ??
            "";
          const docSheet =
            workingIfsDocumentDetails?.docSheet ??
            workingIfsDocumentDetails?.sheetNo ??
            workingIfsDocumentDetails?.DocSheet ??
            workingIfsDocumentDetails?.SheetNo ??
            "";
          const title =
            workingIfsDocumentDetails?.Title ??
            workingIfsDocumentDetails?.title ??
            document?.name ??
            "";
          const format =
            workingIfsDocumentDetails?.FormatSize ??
            workingIfsDocumentDetails?.format ??
            "";
          const fileExtension =
            workingIfsDocumentDetails?.FileExtension ??
            workingIfsDocumentDetails?.fileExtension ??
            getFileExtension(document?.name);
          const derivedDocumentNo =
            docNo != null && docRev != null && `${docNo}` && `${docRev}`
              ? `${docNo} - ${docRev}`
              : "";
          const documentNo =
            workingIfsDocumentDetails?.documentNo ?? derivedDocumentNo;

          const selectedRevisionItem =
            workingIfsDocumentDetails && docClass && docNo && docRev
              ? {
                  class: docClass,
                  docNo,
                  docRev,
                  sheetNo: docSheet,
                  title,
                  format,
                  documentNo,
                  fileExtension,
                }
              : null;

          navigate(APP_ROUTES.checkInNewRevision, {
            state: {
              selectedDocument: {
                key: document.id,
                name: document.name,
                fileType: document.file?.mimeType || "",
                downloadlink: url,
                weblink: document.webUrl,
              },
              selectedDocumentDownloadUrl: url,
              from: APP_ROUTES.workingDocuments,
              selectedRevisionItem,
            },
          });
          break;
        default:
          break;
      }
    }
  };

  const getDownloadUrl = async (key) => {
    let groupId =
      teamsContext.channel !== undefined
        ? teamsContext.channel.membershipType === "Private"
          ? teamsContext.channel.ownerGroupId
          : teamsContext.team.groupId
        : "";
    const result = await onDownLoadOneDriveDocument(
      groupId,
      teamsContext.channel !== undefined ? teamsContext.channel.id : "",
      teamsContext.user.tenant.id,
      key,
      (groupId === "" || groupId === null) &&
        ((teamsContext.channel !== undefined ? teamsContext.channel.id : "") ===
          "" ||
          (teamsContext.channel !== undefined
            ? teamsContext.channel.id
            : "") === null)
        ? ONEDRIVE_ROOT.mainMenu
        : ONEDRIVE_ROOT.channelDoc,
      DOC_CHECK_IN_TYPE.checkinNew,
    );

    // `fetchOneDriveDownloadUrl` returns the redux action:
    //   { meta: { requestStatus }, payload: string }
    return result?.meta?.requestStatus === "fulfilled" &&
      typeof result?.payload === "string" &&
      result.payload.trim() !== ""
      ? result.payload
      : null;
  };

  const navigateWorkingDocumentUnifiedCheckIn = async (
    document,
    options = {},
  ) => {
    if (!document) return;

    const isTemplateDocument =
      document?.IsTemplate === true || document?.isTemplate === true;
    const selectedRevisionItem =
      buildSelectedRevisionItemFromWorkingDocument(document);
    const disableNewRevisionTab = options.disableNewRevisionTab === true;
    const openOnNewDocumentTab =
      isTemplateDocument || disableNewRevisionTab || options.initialTab === 0;

    const title = getFileName(document.name);
    const fileName = document.name;
    onDocTitleChange(title);
    onFileUploadChange(
      [
        {
          name: fileName,
          type: document.file?.mimeType || "",
          size: "0 KB",
          base64: "",
          base64str: "",
        },
      ],
      1,
    );
    const url = await getDownloadUrl(document.id);
    onTeamsFileSelectionChange([
      {
        key: document.id,
        name: document.name,
        documentMode: DOCUMENT_MODE.oneDrive,
        downloadlink: url,
        fileType: document.file?.mimeType || "",
        weblink: document.webUrl,
      },
    ]);

    if (openOnNewDocumentTab) {
      onDocCheckinTypeChange(CHECKIN_NEW);
      onCheckinPageNameChanged(CHECKIN_NEW_PAGE_NAME.basic);
      onBasicDataProgressChange(DATA_LOAD_STATUS.onLoad);
      onObjectConnectionDataLoad(DATA_LOAD_STATUS.onStart);
    } else {
      onDocCheckinTypeChange(CHECKIN_NEW_REVISION);
      onNewRevisionInfoChange(DATA_LOAD_STATUS.refresh);
    }
    onSelectedPageChange(PAGE_NAME.home);

    const defaultTab = 1;
    const initialTab = openOnNewDocumentTab
      ? 0
      : (options.initialTab ?? defaultTab);

    navigate(APP_ROUTES.workingDocumentCheckIn, {
      state: {
        selectedDocument: {
          key: document.id,
          name: document.name,
          fileType: document.file?.mimeType || "",
          downloadlink: url,
          weblink: document.webUrl,
        },
        selectedDocumentDownloadUrl: url,
        from: APP_ROUTES.workingDocuments,
        selectedRevisionItem,
        isTemplate: isTemplateDocument,
        initialTab,
        disableNewRevisionTab,
        isSourceCheckedOut: options.isSourceCheckedOut === true,
      },
    });
  };

  const runWorkingDocumentMenuCheckIn = async (document) => {
    if (!document?.id) return;
    setCheckInStatusGateLoading(true);
    try {
      const selectedRevisionItem =
        buildSelectedRevisionItemFromWorkingDocument(document);
      const hasRevisionIdentifiers = Boolean(
        selectedRevisionItem?.class &&
        selectedRevisionItem?.docNo &&
        selectedRevisionItem?.docRev,
      );

      if (!hasRevisionIdentifiers) {
        await navigateWorkingDocumentUnifiedCheckIn(document, {
          initialTab: 0,
        });
        return;
      }

      const result = await dispatch(
        fetchDocumentRevisionInfo(document),
      ).unwrap();
      const revision = pickRevisionFromFetchResult(result);
      const status = result?.status;
      const hasUsableRevision =
        status === 200 &&
        revision &&
        typeof revision === "object" &&
        Object.keys(revision).length > 0;

      const isTemplateDocument =
        document?.IsTemplate === true || document?.isTemplate === true;

      const isDownloaded = isWorkingDocumentDownloaded(document);
      const isCheckedOut =
        hasUsableRevision && isIfsRevisionCheckedOut(revision);

      if (!isTemplateDocument && isDownloaded && isCheckedOut) {
        await navigateWorkingDocumentUnifiedCheckIn(document, {
          initialTab: 0,
          isSourceCheckedOut: true,
        });
        return;
      }

      if (!isTemplateDocument && isCheckedOut) {
        setIsCheckinMode(true);
        setSelectedDocument(document);
        setDocumentToDelete(document);
        setOpen(true);
        return;
      }
      await navigateWorkingDocumentUnifiedCheckIn(document);
    } catch (err) {
      logger.warn(
        "WorkingDocuments check-in: status refresh failed, opening Details",
        err,
        "CHECKIN",
      );
      setIsCheckinMode(true);
      setSelectedDocument(document);
      setDocumentToDelete(document);
      setOpen(true);
    } finally {
      setCheckInStatusGateLoading(false);
    }
  };

  const handlePreview = (document) => {
    const documentId =
      document?.id ?? document?.documentId ?? document?.key ?? "";
    const tenantId = teamsContext?.user?.tenant?.id || requestTenantId;
    logger.info(
      "WorkingDocuments preview click",
      {
        documentId,
        docName: document?.name,
        tenantId,
        hasChannel: teamsContext?.channel != null,
      },
      "PREVIEW",
    );
    if (!document || !documentId || !tenantId) {
      logger.warn(
        "WorkingDocuments preview aborted due to missing data",
        { hasDocument: !!document, documentId, tenantId },
        "PREVIEW",
      );
      return;
    }

    const groupId =
      teamsContext?.channel != null
        ? teamsContext.channel.membershipType === "Private"
          ? teamsContext.channel.ownerGroupId
          : teamsContext.team?.groupId
        : requestGroupId;
    const channelId =
      teamsContext?.channel != null
        ? teamsContext.channel.id
        : requestChannelId;
    const fileRoot =
      (groupId === "" || groupId === null) &&
      (channelId === "" || channelId === null)
        ? ONEDRIVE_ROOT.mainMenu
        : ONEDRIVE_ROOT.channelDoc;

    try {
      logger.debug(
        "WorkingDocuments preview pre-hook",
        {
          hasStorageModeHandler:
            typeof onDocumentStorageModeChange === "function",
          hasPreviewHook: typeof previewInTeams === "function",
          groupId,
          channelId,
          fileRoot,
        },
        "PREVIEW",
      );
      if (typeof onDocumentStorageModeChange === "function") {
        onDocumentStorageModeChange(DOCUMENT_MODE.oneDrive);
      }
      if (typeof previewInTeams === "function") {
        previewInTeams(document, APP_ROUTES.workingDocuments);
        logger.info(
          "WorkingDocuments preview hook invoked",
          { documentId },
          "PREVIEW",
        );
        return;
      }
    } catch (error) {
      logger.error("WorkingDocuments preview hook failed", error, "PREVIEW");
    }

    if (typeof previewInTeams !== "function") {
      logger.error(
        "WorkingDocuments preview failed: previewInTeams not available",
        null,
        "PREVIEW",
      );
    }
  };

  const handleMenuClick = async (ev, option, document) => {
    onLoginRefreshPreActionClear();
    switch (option) {
      case "WorkingDocumentUnifiedCheckIn": {
        onSetDocumentToDeleteOneDrive({
          checkinSuccess: false,
          id: document?.id,
          deleteRequired: true,
          checkinType: DOC_CHECK_IN_TYPE.checkinNew,
        });
        onAllowSelectionChange(true);
        handleMenuClose(ev);
        await runWorkingDocumentMenuCheckIn(document);
        return;
      }
      case "Details":
        if (document) {
          const formattedDocument = {
            docClass: document.DocClass || "",
            docNo: document.DocNo || "",
            docRev: document.DocRev || "",
            docSheet: document.docSheet || "",
            Title: document.name || "",
            FileExtension: getFileExtension(document.name),
          };
          onContextualMenuDetailsClick(formattedDocument);
        }
        break;

      case "Preview":
        handlePreview(document);
        break;
      default:
        break;
    }
    handleMenuClose(ev);
  };

  const getFileExtension = (filename) => {
    return filename ? filename.split(".").pop() : "";
  };

  function getDocIcon(
    name,
    isCheckedOut = false,
    type = "default",
    isReleased = false,
  ) {
    if (!name) {
      if (isReleased) {
        return type === "avatar"
          ? wordIconAvatar
          : OAS365ICONS.wordReleasedIcon;
      }
      if (isCheckedOut) {
        return type === "avatar" ? wordIconAvatar : OAS365ICONS.wordLockIcon;
      }
      return type === "avatar" ? wordIconAvatar : wordIcon;
    }

    const ext = name.split(".").pop().toLowerCase();

    // File type groups
    const emailExts = ["msg", "eml"];
    const wordExts = [
      "doc",
      "docx",
      "docm",
      "dot",
      "dotm",
      "dotx",
      "rtf",
      "odt",
    ];
    const excelExts = [
      "xls",
      "xlsx",
      "xlsm",
      "csv",
      "xlsb",
      "ods",
      "xlt",
      "xltx",
      "xltm",
    ];
    const pptExts = [
      "ppt",
      "pptx",
      "pptm",
      "potm",
      "potx",
      "pps",
      "ppsx",
      "ppsm",
      "pot",
    ];
    const pdfExts = ["pdf"];
    const imageExts = [
      "jpg",
      "jpeg",
      "png",
      "gif",
      "bmp",
      "tif",
      "tiff",
      "webp",
      "svg",
    ];
    const audioExts = [
      "mp3",
      "wav",
      "aac",
      "ogg",
      "flac",
      "m4a",
      "wma",
      "opus",
    ];
    const videoExts = [
      "mp4",
      "avi",
      "mov",
      "wmv",
      "flv",
      "webm",
      "mkv",
      "mpeg",
      "mpg",
      "3gp",
      "ogv",
    ];
    const archiveExts = [
      "zip",
      "rar",
      "7z",
      "tar",
      "gz",
      "bz2",
      "xz",
      "cab",
      "iso",
    ];
    const textExts = ["txt", "html", "json", "xml", "css", "js", "javascript"];

    // Released icons (same priority as getFileIconPath: released before checked-out)
    if (isReleased) {
      if (emailExts.includes(ext)) {
        return type === "avatar"
          ? outlookIconAvatar
          : OAS365ICONS.outlookReleasedIcon;
      }
      if (wordExts.includes(ext)) {
        return type === "avatar"
          ? wordIconAvatar
          : OAS365ICONS.wordReleasedIcon;
      }
      if (excelExts.includes(ext)) {
        return type === "avatar"
          ? excelIconAvatar
          : OAS365ICONS.excelReleasedIcon;
      }
      if (pptExts.includes(ext)) {
        return type === "avatar"
          ? pptIconAvatar
          : OAS365ICONS.powerpointReleasedIcon;
      }
      if (pdfExts.includes(ext)) {
        return type === "avatar" ? pdfIconAvatar : OAS365ICONS.pdfReleasedIcon;
      }
      if (imageExts.includes(ext)) {
        return type === "avatar"
          ? imageIconAvatar
          : OAS365ICONS.imageReleasedIcon;
      }
      if (audioExts.includes(ext)) {
        return type === "avatar"
          ? audioIconAvatar
          : OAS365ICONS.audioReleasedIcon;
      }
      if (videoExts.includes(ext)) {
        return type === "avatar"
          ? videoIconAvatar
          : OAS365ICONS.videoReleasedIcon;
      }
      if (archiveExts.includes(ext)) {
        return type === "avatar"
          ? archiveIconAvatar
          : OAS365ICONS.archiveReleasedIcon;
      }
      if (textExts.includes(ext)) {
        return type === "avatar"
          ? textIconAvatar
          : OAS365ICONS.textReleasedIcon;
      }
      return type === "avatar" ? otherFileIcon : OAS365ICONS.otherFileIcon;
    }

    // Checked-out icons
    if (isCheckedOut) {
      if (emailExts.includes(ext)) {
        return type === "avatar"
          ? outlookIconAvatar
          : OAS365ICONS.outlookLockIcon;
      }
      if (wordExts.includes(ext)) {
        return type === "avatar" ? wordIconAvatar : OAS365ICONS.wordLockIcon;
      }
      if (excelExts.includes(ext)) {
        return type === "avatar" ? excelIconAvatar : OAS365ICONS.excelLockIcon;
      }
      if (pptExts.includes(ext)) {
        return type === "avatar"
          ? pptIconAvatar
          : OAS365ICONS.powerpointLockIcon;
      }
      if (pdfExts.includes(ext)) {
        return type === "avatar" ? pdfIconAvatar : OAS365ICONS.pdfLockIcon;
      }

      // Images, audio, video, archives, text – use specific avatar icons when available,
      // otherwise fall back to the generic locked document icon.
      if (imageExts.includes(ext)) {
        return type === "avatar" ? imageIconAvatar : OAS365ICONS.imageLockIcon;
      }
      if (audioExts.includes(ext)) {
        return type === "avatar" ? audioIconAvatar : OAS365ICONS.audioLockIcon;
      }
      if (videoExts.includes(ext)) {
        return type === "avatar" ? videoIconAvatar : OAS365ICONS.videoLockIcon;
      }
      if (archiveExts.includes(ext)) {
        return type === "avatar"
          ? archiveIconAvatar
          : OAS365ICONS.archiveLockIcon;
      }
      if (textExts.includes(ext)) {
        return type === "avatar" ? textIconAvatar : OAS365ICONS.textLockIcon;
      }

      // Unknown types
      return type === "avatar" ? otherFileIcon : OAS365ICONS.otherFileIcon;
    }

    // Normal (not checked out) icons
    if (emailExts.includes(ext)) {
      return type === "avatar" ? outlookIconAvatar : OAS365ICONS.outlook;
    }
    if (wordExts.includes(ext)) {
      return type === "avatar" ? wordIconAvatar : wordIcon;
    }
    if (excelExts.includes(ext)) {
      return type === "avatar" ? excelIconAvatar : excelIcon;
    }
    if (pptExts.includes(ext)) {
      return type === "avatar" ? pptIconAvatar : pptIcon;
    }
    if (pdfExts.includes(ext)) {
      return type === "avatar" ? pdfIconAvatar : pdfIcon;
    }

    // Images, audio, video, archives, text – use specific avatar icons when available,
    // otherwise fall back to the generic document icon.
    if (imageExts.includes(ext)) {
      return type === "avatar" ? imageIconAvatar : OAS365ICONS.imageIcon;
    }
    if (audioExts.includes(ext)) {
      return type === "avatar" ? audioIconAvatar : OAS365ICONS.audioFileIcon;
    }
    if (videoExts.includes(ext)) {
      return type === "avatar" ? videoIconAvatar : OAS365ICONS.videoFileIcon;
    }
    if (archiveExts.includes(ext)) {
      return type === "avatar" ? archiveIconAvatar : OAS365ICONS.archive;
    }
    if (textExts.includes(ext)) {
      return type === "avatar" ? textIconAvatar : OAS365ICONS.textIcon;
    }

    // Unknown types
    return type === "avatar" ? otherFileIcon : OAS365ICONS.otherFileIcon;
  }

  const ensureCardPageLoaded = useCallback(
    async (targetPageIndex) => {
      const requiredItems = (targetPageIndex + 1) * workingCardPageSize;
      let loadedCount = visibleFilesData.length;
      while (loadedCount < requiredItems) {
        const resultAction = await loadMoreWorkingDocuments(
          WORKING_DOC_BATCH_SIZE,
        );
        const fetchedItems = Array.isArray(resultAction?.payload?.items)
          ? resultAction.payload.items
          : [];
        if (fetchedItems.length === 0) break;
        loadedCount += fetchedItems.length;
        if (fetchedItems.length < WORKING_DOC_BATCH_SIZE) break;
      }
    },
    [workingCardPageSize, visibleFilesData.length, loadMoreWorkingDocuments],
  );

  const ensureListPageLoaded = useCallback(
    async (targetPageIndex) => {
      const requiredItems = (targetPageIndex + 1) * workingListPageSize;
      let loadedCount = visibleFilesData.length;
      while (loadedCount < requiredItems) {
        const resultAction = await loadMoreWorkingDocuments(
          WORKING_DOC_BATCH_SIZE,
        );
        const fetchedItems = Array.isArray(resultAction?.payload?.items)
          ? resultAction.payload.items
          : [];
        if (fetchedItems.length === 0) break;
        loadedCount += fetchedItems.length;
        if (fetchedItems.length < WORKING_DOC_BATCH_SIZE) break;
      }
    },
    [workingListPageSize, visibleFilesData.length, loadMoreWorkingDocuments],
  );

  const handleCardPageIndexChange = useCallback(
    async (idx) => {
      if (isFetchingMore) return;
      setIsFetchingMore(true);
      try {
        setWorkingCardPageIndex(idx);
        await ensureCardPageLoaded(idx);
      } finally {
        setIsFetchingMore(false);
      }
    },
    [ensureCardPageLoaded, isFetchingMore],
  );

  const handleListPageIndexChange = useCallback(
    async (idx) => {
      if (isFetchingMore) return;
      setIsFetchingMore(true);
      try {
        setWorkingListPageIndex(idx);
        await ensureListPageLoaded(idx);
      } finally {
        setIsFetchingMore(false);
      }
    },
    [ensureListPageLoaded, isFetchingMore],
  );

  const openWorkingDocumentInfo = (ev, file) => {
    // ev?.stopPropagation?.();
    logger.info(
      "WorkingDocuments card click -> open details",
      {
        fileId: file?.id,
        fileName: file?.name,
        beforeOpen: open,
        listStatus: workingDocumentListStatus,
        detailsStatus: workingDocumentStatus,
        checkinType: workingDocumentCheckinType,
      },
      "DIALOG",
    );
    setIsCheckinMode(false);
    setSelectedDocument(file);
    setDocumentToDelete(file);
    setOpen(true);
    if (typeof onViewCopyUploadChange === "function") {
      onViewCopyUploadChange([], 0, 0, false, null);
    }
    logger.debug(
      "WorkingDocuments setOpen(true) invoked",
      {
        fileId: file?.id,
        fileName: file?.name,
      },
      "DIALOG",
    );

    // Non-critical state resets should never block opening the dialog.
    try {
      if (typeof onRefreshCheckinExisting === "function") {
        onRefreshCheckinExisting();
      } else {
        logger.warn(
          "WorkingDocuments onRefreshCheckinExisting is not a function",
          { type: typeof onRefreshCheckinExisting },
          "DIALOG",
        );
      }
    } catch (error) {
      logger.error(
        "WorkingDocuments onRefreshCheckinExisting failed",
        error,
        "DIALOG",
      );
    }

    // Details dialog fetches revision info via useDocumentRevisionInfo when opened
  };

  const openDoc = (url) => {
    openExternalUrl(
      resolveEditInBrowserUrl(
        typeof url === "string" ? url : url != null ? String(url) : "",
      ),
    );
  };

  workingListMenuActionsRef.current = {
    onCheckIn: (file) => {
      onSetDocumentToDeleteOneDrive({
        checkinSuccess: false,
        id: file?.id,
        deleteRequired: false,
        checkinType: DOC_CHECK_IN_TYPE.checkinNew,
      });
      onAllowSelectionChange(true);
      void runWorkingDocumentMenuCheckIn(file);
    },
    onOpenIFS: (file) => openInIFS(file),
    onEditInBrowser: (file) => {
      const url = file?.webUrl ?? file?.WebUrl;
      if (url) openDoc(url);
    },
    onPreview: (file) => handlePreview(file),
    onDeleteFromOneDrive: (file) =>
      handleDeleteFromOneDrive(MENU_EVENT_STUB, file),
    onDetails: (file) => openWorkingDocumentInfo(MENU_EVENT_STUB, file),
  };

  const handleClose = () => {
    logger.info(
      "WorkingDocuments handleClose invoked",
      {
        selectedDocumentId: selectedDocument?.id,
        selectedDocumentName: selectedDocument?.name,
        listStatus: workingDocumentListStatus,
        detailsStatus: workingDocumentStatus,
        checkinStatus: checkinExistingStatus,
      },
      "DIALOG",
    );
    setOpen(false);
    onWorkingIfsDocumentChange([]);
    onWorkingDocumentStatusChange(DOCUMENT_LOAD_STATUS.onStart);
    setDeleteChkBox(false);
    onDocReleaseChange(false);
    if (typeof onViewCopyUploadChange === "function") {
      onViewCopyUploadChange([], 0, 0, false, null);
    }
  };

  // Check-in existing flow: on success show message, set attached doc for highlight, redirect immediately to All Documents
  useEffect(() => {
    if (!checkinExistingFlowSuccess) {
      hasHandledCheckinExistingSuccess.current = false;
      return;
    }
    if (hasHandledCheckinExistingSuccess.current) return;
    hasHandledCheckinExistingSuccess.current = true;
    const displayTitle =
      selectedDocument?.name || selectedDocument?.title || "Document";
    let decodedTitle = displayTitle;
    try {
      decodedTitle = decodeURIComponent(displayTitle);
    } catch (_err) {
      // keep original
    }
    onSuccessMessageInvoke(
      getSuccessMessage(CHECKIN_SUCCESS_TITLE, DocumentCheckin(decodedTitle)),
    );
    // Set attached doc info so All Documents can highlight the checked-in row (same as Check-In New Revision)
    if (
      lastDocumentRevision &&
      typeof lastDocumentRevision.docNo !== "undefined"
    ) {
      dispatch({
        type: ON_ATTACHED_DOC_INFO,
        payload: {
          docClass: lastDocumentRevision.docClass,
          docNo: lastDocumentRevision.docNo,
          docRev: lastDocumentRevision.docRev,
          docSheet: lastDocumentRevision.docSheet,
          title: lastDocumentRevision.Title ?? lastDocumentRevision.title,
        },
      });
    }
    onRequestRefreshAllDocuments?.();
    // Redirect immediately to avoid briefly showing Working Documents again after success.
    navigate(APP_ROUTES.allDocuments);
    // Still refresh Working Documents list in the background so when user returns it's up to date.
    // Defer one tick so the navigation happens first and avoids a visible Working Documents refresh "flash".
    setTimeout(() => {
      refreshWorkingDocuments(50);
    }, 0);
    clearCheckinExistingFlow();
  }, [
    checkinExistingFlowSuccess,
    selectedDocument,
    lastDocumentRevision,
    dispatch,
    onSuccessMessageInvoke,
    clearCheckinExistingFlow,
    refreshWorkingDocuments,
    onRequestRefreshAllDocuments,
    navigate,
  ]);

  useEffect(() => {
    logger.debug(
      "WorkingDocuments dialog state changed",
      {
        open,
        selectedDocumentId: selectedDocument?.id,
        selectedDocumentName: selectedDocument?.name,
        listStatus: workingDocumentListStatus,
        detailsStatus: workingDocumentStatus,
      },
      "DIALOG",
    );
  }, [
    open,
    selectedDocument,
    workingDocumentListStatus,
    workingDocumentStatus,
  ]);

  const _checkInDocument = (docStatusOrWorkingIfsDocument) => {
    const workingIfsDocumentDetails =
      docStatusOrWorkingIfsDocument &&
      typeof docStatusOrWorkingIfsDocument === "object" &&
      "FileState" in docStatusOrWorkingIfsDocument
        ? docStatusOrWorkingIfsDocument
        : null;

    const docStatus =
      workingIfsDocumentDetails?.FileState ?? docStatusOrWorkingIfsDocument;

    switch (docStatus) {
      case FILE_STATE.checkedIn:
      default:
        onSetDocumentToDeleteOneDrive({
          checkinSuccess: false,
          id: selectedDocument.id,
          deleteRequired: true,
          checkinType: DOC_CHECK_IN_TYPE.checkinNewRevision,
        });
        onAllowSelectionChange(true);
        handleCheckIn(
          CHECKIN_NEW_REVISION,
          selectedDocument,
          false,
          workingIfsDocumentDetails,
        );
        handleClose();
        break;
      case FILE_STATE.checkedOut:
        handleCheckIn(
          DOC_CHECK_IN_TYPE.checkinExisting,
          selectedDocument,
          deleteChkBox,
          workingIfsDocumentDetails,
        );
        break;
    }
  };

  const _checkinButtonText = (docStatus) => {
    switch (docStatus) {
      case FILE_STATE.checkedIn:
      default:
        return CHECKIN_BUTTON_TEXT_TYPE.checkinNewRevision;
      case FILE_STATE.checkedOut:
        return CHECKIN_BUTTON_TEXT_TYPE.checkinExisting;
    }
  };

  /************************** Check-in Existing Implementation ***********************/

  const _onDownloadUrl = async (document) => {
    onCheckinExistingStatusChange(DOCUMENT_LOAD_STATUS.onDownloading);
    await getDownloadUrl(document.id);
    onCheckinExistingStatusChange(DOCUMENT_LOAD_STATUS.onUploading);
  };

  const _checkinExistingRevision = async (
    document,
    url,
    tokenRefreshPreActionInvoke,
  ) => {
    //const isDeleteRequired = isDeleteWorkingDocument();
    let fileName = document.name;
    let fileData = await _getBase64FromUrl(url);
    let fileInfo = {
      documentRevision: workingIfsDocument,
      fileName: fileName,
      fileData: fileData,
      objectConnection: [],
      oneDriveFile: document,
    };

    await onCheckinExistingDocument(
      fileInfo,
      isDeleteWorkingDocument(),
      docReleaseStatus,
      createViewCopy,
      uploadViewCopyCount > 0,
      tokenRefreshPreActionInvoke,
    );
  };

  function isDeleteWorkingDocument() {
    const isDeleteRequired =
      isOneDriveDocDeleteEnable === true ? true : deleteChkBox;
    return isDeleteRequired;
  }

  const _updateWorkingDocument = async () => {
    let groupId =
      teamsContext.channel !== undefined
        ? teamsContext.channel.membershipType === "Private"
          ? teamsContext.channel.ownerGroupId
          : teamsContext.team.groupId
        : "";
    onUploadWorkingDocument(
      workingDocument,
      groupId,
      teamsContext.channel !== undefined ? teamsContext.channel.id : "",
      teamsContext.user.tenant.id,
      (groupId === "" || groupId === null) &&
        ((teamsContext.channel !== undefined ? teamsContext.channel.id : "") ===
          "" ||
          (teamsContext.channel !== undefined
            ? teamsContext.channel.id
            : "") === null)
        ? ONEDRIVE_ROOT.mainMenu
        : ONEDRIVE_ROOT.channelDoc,
      DOC_CHECK_IN_TYPE.checkinExisting,
    );
  };

  const _getBase64FromUrl = async (url) => {
    try {
      const data = await fetch(url);
      const blob = await data.blob();
      let messageBox = {
        type: ERROR_TYPE,
        message: ONEDRIVE_DATA_NOT_FOUND,
        errorMessage: "",
        error: null,
      };
      if (blob !== null) {
        return new Promise((resolve) => {
          const reader = new FileReader();
          reader.readAsDataURL(blob);
          reader.onloadend = () => {
            const base64data = reader.result;
            resolve(base64data);
          };
        });
      } else {
        onWorkingDocumentStatusChange(DOCUMENT_LOAD_STATUS.noData);
        messageBox.message = ONEDRIVE_DATA_NOT_FOUND;
        onErrorMessageInvoke(messageBox);
      }

      return null;
    } catch (ex) {
      onWorkingDocumentStatusChange(DOCUMENT_LOAD_STATUS.onError);
      onExceptionMessageInvoke(ex.message);
    }
  };

  /************************** End of Check-in Existing Implementation ***********************/

  const hasActiveWorkingQuery =
    (appliedWorkingSearchText ?? "").length > 0 ||
    (workingDocumentFileType != null &&
      workingDocumentFileType !== "" &&
      workingDocumentFileType !== FILE_TYPES.allFiles);
  const showInitialBlockingLoader =
    isListLoading && !visibleFilesData?.length && !hasActiveWorkingQuery;
  const workingListErrorMessage =
    typeof listError === "string" && listError.length > 0
      ? listError
      : messageBoxInfo?.message || "Something went wrong. Please try again.";

  return (
    <div
      style={{
        height: "100%",
        minHeight: 0,
        display: "flex",
        flexDirection: "column",
      }}
    >
      {showInitialBlockingLoader ? (
        <div style={loaderBorderStyle}>
          <Loader />
        </div>
      ) : (
        <>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              height: "100%",
              minHeight: 0,
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                gap: "10px",
                flexWrap: "wrap",
                width: "100%",
                position: "relative",
                zIndex: 2,
                flexShrink: 0,
                backgroundColor: theme.colors.backgroundColor,
                padding: "8px 0",
                rowGap: "8px",
              }}
            >
              <Box sx={{ flex: "1 1 260px", minWidth: "240px" }}>
                <SearchBar
                  value={workingDocumentSearchText}
                  onChange={setWorkingDocumentSearchText}
                  loading={isListLoading}
                  onSearch={() => {
                    const term = (workingDocumentSearchText ?? "").trim();
                    setAppliedWorkingSearchText(term);
                    void loadWorkingDocuments({ searchText: term });
                  }}
                  onClearAndSearch={() => {
                    setWorkingDocumentSearchText("");
                    setAppliedWorkingSearchText("");
                    void loadWorkingDocuments({ searchText: "" });
                  }}
                  placeholder="Search for documents"
                  controlHeight="40px"
                  showFilterButton
                  isFilterVisible={isWorkingFilterVisible}
                  onFilterVisibleChange={(visible) => {
                    setIsWorkingFilterVisible(visible);
                    if (!visible)
                      setWorkingDocumentFileType(FILE_TYPES.allFiles);
                  }}
                  filterContent={workingFilterContent}
                />
              </Box>
              <ToggleButton
                value={workingViewMode}
                aria-label={
                  workingViewMode === "list"
                    ? "switch to card view"
                    : "switch to list view"
                }
                onClick={() =>
                  setWorkingViewMode((prev) =>
                    prev === "list" ? "card" : "list",
                  )
                }
                sx={{
                  height: "32px",
                  borderColor: theme.colors.Addovation20Grey ?? "#d8d8d8",
                  color: theme.colors.themeDarkColor ?? "#249f5d",
                  textTransform: "none",
                  fontFamily: "Poppins, sans-serif",
                  fontSize: "12px",
                  paddingX: 1,
                  backgroundColor: theme.colors.addovation20Green ?? "#e2efdf",
                }}
              >
                {workingViewMode === "list" ? (
                  <ListAltOutlinedIcon sx={{ fontSize: 16 }} />
                ) : (
                  <ViewModuleIcon sx={{ fontSize: 16 }} />
                )}
              </ToggleButton>
            </Box>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                flex: "1 1 auto",
                width: "100%",
                marginTop: "8px",
                minHeight: 0,
                overflow: "hidden",
              }}
            >
              {isListLoading ? (
                <Box
                  sx={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    padding: "24px 0",
                  }}
                >
                  <Loader />
                </Box>
              ) : isListError ? (
                <WorkingDocumentsErrorDisplay
                  message={workingListErrorMessage}
                />
              ) : !visibleFilesData?.length ? (
                <WorkingDocumentsNoDataDisplay />
              ) : (
                <>
                  <Box
                    sx={{
                      flex: "1 1 auto",
                      minHeight: 0,
                      overflowY: "auto",
                      overflowX: "auto",
                      width: "100%",
                      display: workingViewMode === "list" ? "block" : "flex",
                      flexWrap: workingViewMode === "list" ? "nowrap" : "wrap",
                      boxSizing: "border-box",
                      gap: "2px",
                      justifyContent: "flex-start",
                      ...workingDocumentsScrollStyles,
                    }}
                  >
                    {workingViewMode === "list" ? (
                      <>
                        <DocumentsTable
                          hidePagination
                          loading={false}
                          isError={false}
                          items={workingListItems}
                          columns={workingVisibleListColumns}
                          selection={workingListSelection}
                          stickyHeader={false}
                          disableScrollablePane={true}
                          disableVirtualization={true}
                        />
                        {!isFetchingMore &&
                        visibleFilesData.length > 0 &&
                        listDisplayedFiles.length === 0 ? (
                          <Typography
                            sx={{
                              width: "100%",
                              textAlign: "center",
                              marginTop: "20px",
                              color: theme?.colors?.fontColor ?? "#333",
                              fontFamily: "Poppins, sans-serif",
                              fontSize: "14px",
                            }}
                          >
                            No documents on this page.
                          </Typography>
                        ) : null}
                      </>
                    ) : (
                      cardDisplayedFiles.map((file) => {
                        const isTarget =
                          deleteDialogOpen &&
                          documentToDelete &&
                          (file.id === documentToDelete.id ||
                            file.name === documentToDelete.name);
                        const isDimmed =
                          deleteDialogOpen && documentToDelete && !isTarget;
                        return (
                          <WorkingDocumentCard
                            key={file.id || file.name}
                            file={file}
                            theme={theme}
                            anchorEl={anchorEl}
                            selectedDocId={selectedDocId}
                            selectedDocument={selectedDocument}
                            onOpenDetails={openWorkingDocumentInfo}
                            onMenuOpen={handleMenuOpen}
                            onMenuClose={handleMenuClose}
                            onMenuClick={handleMenuClick}
                            onOpenDoc={openDoc}
                            onOpenInIFS={openInIFS}
                            onSetDocumentToDeleteOneDrive={
                              onSetDocumentToDeleteOneDrive
                            }
                            onAllowSelectionChange={onAllowSelectionChange}
                            onDeleteFromOneDrive={handleDeleteFromOneDrive}
                            isDeleteTarget={isTarget}
                            isDimmed={isDimmed}
                            viewMode={workingViewMode}
                          />
                        );
                      })
                    )}
                    {workingViewMode !== "list" &&
                      !isFetchingMore &&
                      cardDisplayedFiles.length === 0 &&
                      visibleFilesData.length > 0 && (
                        <Typography
                          sx={{
                            width: "100%",
                            textAlign: "center",
                            marginTop: "20px",
                            color: theme?.colors?.fontColor ?? "#333",
                            fontFamily: "Poppins, sans-serif",
                            fontSize: "14px",
                          }}
                        >
                          No documents on this page.
                        </Typography>
                      )}
                  </Box>

                  {!isWorkingListView && (
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        gap: 1,
                        width: "100%",
                        flexShrink: 0,
                        padding: "6px 0 4px",
                        backgroundColor: theme.colors.backgroundColor,
                      }}
                    >
                      {isFetchingMore ? (
                        <CircularProgress size={22} sx={{ color: "inherit" }} />
                      ) : null}
                      <DocumentsPagination
                        navigationLoading={isFetchingMore}
                        pageSize={workingCardPageSize}
                        documents={cardDisplayedFiles}
                        selectedPageIndex={workingCardPageIndex}
                        hasNext={workingCardHasNext}
                        onPageIndexChange={handleCardPageIndexChange}
                      />
                    </Box>
                  )}

                  {isWorkingListView && (
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        gap: 1,
                        width: "100%",
                        flexShrink: 0,
                        padding: "6px 0 4px",
                        backgroundColor: theme.colors.backgroundColor,
                      }}
                    >
                      {isFetchingMore ? (
                        <CircularProgress size={22} sx={{ color: "inherit" }} />
                      ) : null}
                      <DocumentsPagination
                        navigationLoading={isFetchingMore}
                        pageSize={workingListPageSize}
                        documents={listDisplayedFiles}
                        selectedPageIndex={workingListPageIndex}
                        hasNext={workingListHasNext}
                        onPageIndexChange={handleListPageIndexChange}
                      />
                    </Box>
                  )}
                </>
              )}
            </Box>
          </div>

          <ReusableDialog
            isOpen={previewState?.loading ?? false}
            onClose={() => {}}
            title="Preview in Teams"
            showHeader={false}
            variant="info"
            centerContent={true}
            dialogMinHeight={40}
            bodyMinHeight={40}
          >
            <DocumentDetailsLoadingContent
              message={previewState?.loadingMessage}
            />
          </ReusableDialog>
          <ReusableDialog
            isOpen={(uploadState?.loading ?? false) && isPanelActive}
            onClose={() => {}}
            title="Download"
            showHeader={false}
            variant="info"
            centerContent={true}
            dialogMinHeight={40}
            bodyMinHeight={40}
          >
            <DocumentDetailsLoadingContent message="Downloading document.." />
          </ReusableDialog>
          <ReusableMessageDialog
            isOpen={openIfsDialogOpen}
            onClose={closeOpenIfsDialog}
            title={openIfsDialogTitle}
            showHeader={false}
            message={openIfsDialogMessage}
            errorMessage={openIfsDialogDetails}
            variant={openIfsDialogType}
            showDetailsButton={!openIfsLoading}
            showOkButton={!openIfsLoading && openIfsDialogType !== "info"}
            isLoading={openIfsLoading}
            loadingText="Generating URLs..."
          />

          {deleteState?.loading ? (
            <ReusableMessageDialog
              isOpen
              onClose={clearDeleteState}
              title={DELETE_DOCUMENT_TITLE}
              showHeader={false}
              message=""
              errorMessage=""
              variant="info"
              showDetailsButton={false}
              showOkButton={false}
              isLoading
              loadingText="Deleting document..."
            />
          ) : null}

          <ConfirmModal
            isOpen={deleteDialogOpen}
            onConfirm={handleConfirmDelete}
            onCancel={handleDeleteDialogClose}
            theme={theme}
            type="delete"
            title={
              pendingDeleteIsUndoCheckout
                ? UNDO_CHECKOUT_DELETE_CONFIRMATION_TITLE
                : DELETE_DOCUMENT_TITLE
            }
            subText={
              deleteError
                ? deleteError
                : documentToDelete
                  ? pendingDeleteIsUndoCheckout
                    ? getUndoCheckoutDeleteConfirmation(
                        getTitle(
                          documentToDelete?.name ||
                            documentToDelete?.title ||
                            "this document",
                        ),
                      )
                    : `Are you sure you want to delete "${getTitle(documentToDelete?.name || documentToDelete?.title || "this document")}" from OneDrive?`
                  : DELETE_DOCUMENT_SUB_TITLE
            }
            isDeleting={false}
          />
        </>
      )}
      <ReusableMessageDialog
        isOpen={Boolean(checkoutFlow?.loading)}
        onClose={() => {}}
        title={
          checkoutFlow?.lastOperationWasCheckout
            ? "Check-out"
            : "Undo check-out"
        }
        showHeader={false}
        message={checkoutFlow?.message}
        variant={checkoutFlow?.dialogVariant ?? "info"}
        isLoading={checkoutFlow?.loading ?? false}
        loadingText={checkoutFlow?.message}
      />
      <ReusableDialog
        isOpen={checkInStatusGateLoading}
        onClose={() => {}}
        title="Check-in"
        showHeader={false}
        variant="info"
        centerContent={true}
        dialogMinHeight={40}
        bodyMinHeight={40}
      >
        <DocumentDetailsLoadingContent message="Opening Check In window.." />
      </ReusableDialog>
      <CheckinExistingProcessDialog
        isOpen={
          checkinExistingFlowLoading ||
          (checkinExistingFlowStatus === CHECKIN_EXISTING_STATUS.ERROR &&
            !!checkinExistingFlowMessage)
        }
        onClose={() => {
          clearCheckinExistingFlow();
        }}
        theme={theme}
      />
      <WorkingDocumentDetailsDialog
        isOpen={open}
        onClose={handleClose}
        isCheckinMode={isCheckinMode}
        theme={theme}
        getDocIcon={getDocIcon}
        formatLastAction={formatIfsDocumentLastActionDisplay}
        deleteChkBox={deleteChkBox}
        setDeleteChkBox={setDeleteChkBox}
        isOneDriveDocDeleteEnable={isOneDriveDocDeleteEnable}
        selectedDocument={selectedDocument}
        docReleaseStatus={docReleaseStatus}
        onReleaseChange={(ev) => onDocReleaseChange(ev.target.checked)}
        viewCopyFiles={viewCopyFiles}
        viewRequired={viewRequired}
        uploadViewCopyCount={uploadViewCopyCount}
        createViewCopy={createViewCopy}
        onCreateViewCopySelect={onCreateViewCopySelect}
        onViewCopyUploadChange={onViewCopyUploadChange}
        onSetDocumentToDeleteOneDrive={onSetDocumentToDeleteOneDrive}
        onCheckIn={_checkInDocument}
        onCheckinProcessStarted={handleClose}
        getCheckinButtonText={_checkinButtonText}
        docClassFormatList={docClassFormatList}
      />
    </div>
  );
};

export default WorkingDocuments;
